// Native MG export: 20 separate Americana Decor Metallics listings; 24K Gold first.
window.MG_SWATCH_SETS = window.MG_SWATCH_SETS || {};
window.MG_SWATCH_SETS["Colors-ADMetallics"] = {
  "meta": {
    "appearance": {
      "background_color": "#f7f4ec",
      "background_image": "",
      "background_image_style": "center",
      "border_color": "#cfcfcf",
      "border_radius_px": 6,
      "border_scope": "image_text",
      "border_size": 2,
      "gradient_angle": 42,
      "gradient_color": "#f7f4ec",
      "image_radius_px": 6,
      "product_image_padding": 0,
      "shadow_size": 4,
      "text_behavior": "wrap_text",
      "text_color": "#000000",
      "text_size_desktop": 13,
      "text_size_mobile": 12,
      "text_style": "normal"
    },
    "selected_appearance": {
      "background_color": "#f5f5f5",
      "background_image": "",
      "background_image_style": "center",
      "border_color": "#12316f",
      "border_radius_px": 6,
      "border_scope": "image_text",
      "border_size": 4,
      "gradient_color": "#f7f4ec",
      "image_radius_px": 4,
      "product_image_padding": 0,
      "shadow_size": 8,
      "text_color": "#000000",
      "text_style": "normal",
      "text_size_mobile": 12,
      "text_size_desktop": 13
    },
    "corner_radius_px": 6
  },
  "rows": [
    {
      "custom_html": "<span hidden data-metallics-compact-colors></span><style>:is([data-mg-set=\"Colors-ADMetallics\"],[data-mg-set$=\"-metallic_colors\"],.mgps-modal:has(img[src*=\"ADMTL\"][src*=\"-3d\"])) .mgps-img-wrap{--mgps-row-aspect:8 / 5!important;aspect-ratio:8 / 5!important;height:auto!important;min-height:0!important}:is([data-mg-set=\"Colors-ADMetallics\"],[data-mg-set$=\"-metallic_colors\"],.mgps-modal:has(img[src*=\"ADMTL\"][src*=\"-3d\"])) .mgps-img-inner img{width:100%!important;height:100%!important;object-fit:cover!important;object-position:center!important}.mgps-row:has([data-metallics-compact-colors]){display:none!important}</style><style data-readable-swatch-labels>@media(max-width:749px){:is([data-mg-set=\"Colors-ADMetallics\"],[data-mg-set$=\"-metallic_colors\"],.mgps-modal:has(img[src*=\"ADMTL\"]),[data-mg-set=\"Colors-Bloom2oz\"],[data-mg-set=\"Colors-Bloom4pk\"],[data-mg-set$=\"-bloom_colors\"],.mgps-modal:has(img[src*=\"Swatch-DPF\"])) .mgps-card-bottom{padding:6px 3px!important;min-height:38px!important;box-sizing:border-box!important}:is([data-mg-set=\"Colors-ADMetallics\"],[data-mg-set$=\"-metallic_colors\"],.mgps-modal:has(img[src*=\"ADMTL\"]),[data-mg-set=\"Colors-Bloom2oz\"],[data-mg-set=\"Colors-Bloom4pk\"],[data-mg-set$=\"-bloom_colors\"],.mgps-modal:has(img[src*=\"Swatch-DPF\"])) .mgps-title{white-space:normal!important;overflow-wrap:normal!important;word-break:normal!important;font-size:12px!important;line-height:1.15!important}:is([data-mg-set=\"Colors-ADMetallics\"],[data-mg-set$=\"-metallic_colors\"],.mgps-modal:has(img[src*=\"ADMTL\"]),[data-mg-set=\"Colors-Bloom2oz\"],[data-mg-set=\"Colors-Bloom4pk\"],[data-mg-set$=\"-bloom_colors\"],.mgps-modal:has(img[src*=\"Swatch-DPF\"])) .mgps-title span{display:inline!important;white-space:normal!important;transform:none!important;letter-spacing:normal!important}}</style><style data-ri29-centered-colors>.mgps-modal:has([data-metallics-compact-colors]){align-items:center!important;justify-content:center!important;padding-block:16px!important;box-sizing:border-box!important}.mgps-modal:has([data-metallics-compact-colors]) .mgps-modal__dialog{max-height:calc(100vh - 32px)!important;max-height:calc(100dvh - 32px)!important;margin:0!important}.mgps-modal:has([data-metallics-compact-colors]) .mgps-modal__body{min-height:0!important;max-height:calc(100vh - 32px)!important;max-height:calc(100dvh - 32px)!important;overflow:auto!important;overscroll-behavior:contain}.mgps-modal:has([data-metallics-compact-colors]) .mgps-thumb-row[data-swatch-row=\"true\"]{justify-content:center!important}</style>",
      "custom_max_width_px": "0",
      "custom_template_id": "mgps-custom-template--28071579648134__metallic_colors-0",
      "custom_width_desktop_percent": "100",
      "custom_width_mobile_percent": "100",
      "fit_row": false,
      "heading": "",
      "heading_justify": "center",
      "img_ratio": "1:1",
      "margin_bottom": 0,
      "margin_top": "0",
      "row_height": 0,
      "row_justify": "center",
      "subheading": "",
      "swatch_row": false,
      "swatches": [],
      "videos": []
    },
    {
      "block_type": "mg_row",
      "find_product_handle_contains": "",
      "fit_row": true,
      "heading": "<h2>Metallic colors</h2>",
      "heading_justify": "left",
      "img_ratio": "1:1",
      "margin_bottom": 10,
      "margin_top": 0,
      "more_popup_text": "More",
      "padding_between_rows": 8,
      "padding_between_rows_desktop": 8,
      "padding_between_rows_mobile": 8,
      "product_handle_contains": "",
      "random_zoom_max": "0",
      "randomize_zoom_area": false,
      "row_display_type": "scale_to_fit",
      "row_display_type_desktop": "scale_to_fit",
      "row_display_type_mobile": "scale_to_fit",
      "row_height": "0",
      "row_height_desktop": "0",
      "row_height_mobile": "0",
      "row_justify": "center",
      "subheading": "",
      "swatch_image_zoom": "100",
      "swatch_row": true,
      "swatch_vertical_justify": "fit_to_height",
      "swatches": [
        {
          "alt": "24K Gold",
          "available": true,
          "buttons_over_image": false,
          "cta": {
            "href": "/products/americana-decor-metallics-24k-gold",
            "text": "Shop"
          },
          "desc_html": "",
          "html_desc": "",
          "learn_more_text": "",
          "margin_bottom": 0,
          "margin_top": 0,
          "open_set_key": "",
          "price": "$15.04",
          "price_num": 15.04,
          "product_id": 15451888124038,
          "product_image_id": 0,
          "product_image_scale": "100",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/ADMTL04-24k-gold-master.png?v=1793150187&width=400",
          "product_url": "/products/americana-decor-metallics-24k-gold",
          "product_variant_id": 67786296787078,
          "scale": "100",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "swatch_image_zoom": "100",
          "swatch_mode": true,
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/ADMTL04-24k-gold-3d.png?v=1793143401&width=400",
          "title": "24K Gold",
          "type": "product",
          "vjust": "center"
        },
        {
          "alt": "Champagne Gold",
          "available": true,
          "buttons_over_image": false,
          "cta": {
            "href": "/products/americana-decor-metallics-champagne-gold",
            "text": "Shop"
          },
          "desc_html": "",
          "html_desc": "",
          "learn_more_text": "",
          "margin_bottom": 0,
          "margin_top": 0,
          "open_set_key": "",
          "price": "$15.04",
          "price_num": 15.04,
          "product_id": 15451888156806,
          "product_image_id": 0,
          "product_image_scale": "100",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/ADMTL02-champagne-gold-master.png?v=1793150187&width=400",
          "product_url": "/products/americana-decor-metallics-champagne-gold",
          "product_variant_id": 67786296819846,
          "scale": "100",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "swatch_image_zoom": "100",
          "swatch_mode": true,
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/ADMTL02-champagne-gold-3d.png?v=1793143401&width=400",
          "title": "Champagne Gold",
          "type": "product",
          "vjust": "center"
        },
        {
          "alt": "Soft Gold",
          "available": true,
          "buttons_over_image": false,
          "cta": {
            "href": "/products/americana-decor-metallics-soft-gold",
            "text": "Shop"
          },
          "desc_html": "",
          "html_desc": "",
          "learn_more_text": "",
          "margin_bottom": 0,
          "margin_top": 0,
          "open_set_key": "",
          "price": "$4.99",
          "price_num": 4.99,
          "product_id": 15451888189574,
          "product_image_id": 0,
          "product_image_scale": "100",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/ADMTL14-soft-gold-master.png?v=1793150186&width=400",
          "product_url": "/products/americana-decor-metallics-soft-gold",
          "product_variant_id": 67786296885382,
          "scale": "100",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "swatch_image_zoom": "100",
          "swatch_mode": true,
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/ADMTL14-soft-gold-3d.png?v=1793143401&width=400",
          "title": "Soft Gold",
          "type": "product",
          "vjust": "center"
        },
        {
          "alt": "Vintage Brass",
          "available": true,
          "buttons_over_image": false,
          "cta": {
            "href": "/products/americana-decor-metallics-vintage-brass",
            "text": "Shop"
          },
          "desc_html": "",
          "html_desc": "",
          "learn_more_text": "",
          "margin_bottom": 0,
          "margin_top": 0,
          "open_set_key": "",
          "price": "$15.04",
          "price_num": 15.04,
          "product_id": 15451888255110,
          "product_image_id": 0,
          "product_image_scale": "100",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/ADMTL05-vintage-brass-master.png?v=1793150188&width=400",
          "product_url": "/products/americana-decor-metallics-vintage-brass",
          "product_variant_id": 67786296918150,
          "scale": "100",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "swatch_image_zoom": "100",
          "swatch_mode": true,
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/ADMTL05-vintage-brass-3d.png?v=1793143401&width=400",
          "title": "Vintage Brass",
          "type": "product",
          "vjust": "center"
        },
        {
          "alt": "Bronze",
          "available": true,
          "buttons_over_image": false,
          "cta": {
            "href": "/products/americana-decor-metallics-bronze",
            "text": "Shop"
          },
          "desc_html": "",
          "html_desc": "",
          "learn_more_text": "",
          "margin_bottom": 0,
          "margin_top": 0,
          "open_set_key": "",
          "price": "$15.04",
          "price_num": 15.04,
          "product_id": 15451888320646,
          "product_image_id": 0,
          "product_image_scale": "100",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/ADMTL06-bronze-master.png?v=1793150187&width=400",
          "product_url": "/products/americana-decor-metallics-bronze",
          "product_variant_id": 67786296983686,
          "scale": "100",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "swatch_image_zoom": "100",
          "swatch_mode": true,
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/ADMTL06-bronze-3d.png?v=1793143401&width=400",
          "title": "Bronze",
          "type": "product",
          "vjust": "center"
        },
        {
          "alt": "Antique Bronze",
          "available": true,
          "buttons_over_image": false,
          "cta": {
            "href": "/products/americana-decor-metallics-antique-bronze",
            "text": "Shop"
          },
          "desc_html": "",
          "html_desc": "",
          "learn_more_text": "",
          "margin_bottom": 0,
          "margin_top": 0,
          "open_set_key": "",
          "price": "$4.99",
          "price_num": 4.99,
          "product_id": 15451888353414,
          "product_image_id": 0,
          "product_image_scale": "100",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/ADMTL08-antique-bronze-master.png?v=1793150188&width=400",
          "product_url": "/products/americana-decor-metallics-antique-bronze",
          "product_variant_id": 67786297016454,
          "scale": "100",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "swatch_image_zoom": "100",
          "swatch_mode": true,
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/ADMTL08-antique-bronze-3d.png?v=1793143401&width=400",
          "title": "Antique Bronze",
          "type": "product",
          "vjust": "center"
        },
        {
          "alt": "Copper",
          "available": true,
          "buttons_over_image": false,
          "cta": {
            "href": "/products/americana-decor-metallics-copper",
            "text": "Shop"
          },
          "desc_html": "",
          "html_desc": "",
          "learn_more_text": "",
          "margin_bottom": 0,
          "margin_top": 0,
          "open_set_key": "",
          "price": "$15.04",
          "price_num": 15.04,
          "product_id": 15451888386182,
          "product_image_id": 0,
          "product_image_scale": "100",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/ADMTL10-copper-master.png?v=1793150187&width=400",
          "product_url": "/products/americana-decor-metallics-copper",
          "product_variant_id": 67786297049222,
          "scale": "100",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "swatch_image_zoom": "100",
          "swatch_mode": true,
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/ADMTL10-copper-3d.png?v=1793143400&width=400",
          "title": "Copper",
          "type": "product",
          "vjust": "center"
        },
        {
          "alt": "Rose Gold",
          "available": true,
          "buttons_over_image": false,
          "cta": {
            "href": "/products/americana-decor-metallics-rose-gold",
            "text": "Shop"
          },
          "desc_html": "",
          "html_desc": "",
          "learn_more_text": "",
          "margin_bottom": 0,
          "margin_top": 0,
          "open_set_key": "",
          "price": "$15.04",
          "price_num": 15.04,
          "product_id": 15451888418950,
          "product_image_id": 0,
          "product_image_scale": "100",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/ADMTL03-rose-gold-master.png?v=1793150187&width=400",
          "product_url": "/products/americana-decor-metallics-rose-gold",
          "product_variant_id": 67786297081990,
          "scale": "100",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "swatch_image_zoom": "100",
          "swatch_mode": true,
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/ADMTL03-rose-gold-3d.png?v=1793143401&width=400",
          "title": "Rose Gold",
          "type": "product",
          "vjust": "center"
        },
        {
          "alt": "Pearl",
          "available": true,
          "buttons_over_image": false,
          "cta": {
            "href": "/products/americana-decor-metallics-pearl",
            "text": "Shop"
          },
          "desc_html": "",
          "html_desc": "",
          "learn_more_text": "",
          "margin_bottom": 0,
          "margin_top": 0,
          "open_set_key": "",
          "price": "$15.04",
          "price_num": 15.04,
          "product_id": 15451888484486,
          "product_image_id": 0,
          "product_image_scale": "100",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/ADMTL01-pearl-master.png?v=1793150187&width=400",
          "product_url": "/products/americana-decor-metallics-pearl",
          "product_variant_id": 67786297147526,
          "scale": "100",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "swatch_image_zoom": "100",
          "swatch_mode": true,
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/ADMTL01-pearl-3d.png?v=1793143400&width=400",
          "title": "Pearl",
          "type": "product",
          "vjust": "center"
        },
        {
          "alt": "Silver",
          "available": true,
          "buttons_over_image": false,
          "cta": {
            "href": "/products/americana-decor-metallics-silver",
            "text": "Shop"
          },
          "desc_html": "",
          "html_desc": "",
          "learn_more_text": "",
          "margin_bottom": 0,
          "margin_top": 0,
          "open_set_key": "",
          "price": "$15.04",
          "price_num": 15.04,
          "product_id": 15451888550022,
          "product_image_id": 0,
          "product_image_scale": "100",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/ADMTL13-silver-master.png?v=1793150187&width=400",
          "product_url": "/products/americana-decor-metallics-silver",
          "product_variant_id": 67786297475206,
          "scale": "100",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "swatch_image_zoom": "100",
          "swatch_mode": true,
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/ADMTL13-Silver-3D-Swatch.png?v=1793150759&width=400",
          "title": "Silver",
          "type": "product",
          "vjust": "center"
        },
        {
          "alt": "Sterling Silver",
          "available": true,
          "buttons_over_image": false,
          "cta": {
            "href": "/products/americana-decor-metallics-sterling-silver",
            "text": "Shop"
          },
          "desc_html": "",
          "html_desc": "",
          "learn_more_text": "",
          "margin_bottom": 0,
          "margin_top": 0,
          "open_set_key": "",
          "price": "$15.04",
          "price_num": 15.04,
          "product_id": 15451888582790,
          "product_image_id": 0,
          "product_image_scale": "100",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/ADMTL07-sterling-silver-master.png?v=1793150187&width=400",
          "product_url": "/products/americana-decor-metallics-sterling-silver",
          "product_variant_id": 67786297507974,
          "scale": "100",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "swatch_image_zoom": "100",
          "swatch_mode": true,
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/ADMTL07-Sterling-Silver-3D-Swatch.png?v=1793150759&width=400",
          "title": "Sterling Silver",
          "type": "product",
          "vjust": "center"
        },
        {
          "button_appearance_source": "inherit_from_parent",
          "button_image": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Americana-Metallics-View-All-20261027.png?v=1793144023&width=400",
          "button_image_alt": "View all Americana Decor Metallics colors",
          "button_justify": "left",
          "button_margin_top": "10",
          "button_max_width_px": "0",
          "button_style": "swatch",
          "button_text": "<p>View All</p>",
          "button_width_percent": 100,
          "include_visible_swatches_in_popup": true,
          "popup_swatches_per_row_desktop": "6",
          "popup_swatches_per_row_mobile": "4",
          "popup_title": "",
          "preset_button_background_color": "#f7f4ec",
          "preset_button_background_image": "",
          "preset_button_background_image_style": "center",
          "preset_button_border_color": "#cfcfcf",
          "preset_button_border_radius_px": 6,
          "preset_button_border_scope": "image_text",
          "preset_button_border_size": 2,
          "preset_button_gradient_angle": 42,
          "preset_button_gradient_color": "#f7f4ec",
          "preset_button_heading_justify": "left",
          "preset_button_image": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Americana-Metallics-View-All-20261027.png?v=1793144023&width=400",
          "preset_button_image_alt": "View all Americana Decor Metallics colors",
          "preset_button_image_height_desktop": "0",
          "preset_button_image_height_mobile": "0",
          "preset_button_image_radius_px": 6,
          "preset_button_product_image_padding": 0,
          "preset_button_shadow_size": 4,
          "preset_button_text_behavior": "wrap_text",
          "preset_button_text_color": "#000000",
          "preset_button_text_size_desktop": 14,
          "preset_button_text_size_mobile": 13,
          "preset_button_text_style": "normal",
          "type": "popup_remaining_swatches_trigger"
        },
        {
          "alt": "Tin",
          "available": true,
          "buttons_over_image": false,
          "cta": {
            "href": "/products/americana-decor-metallics-tin",
            "text": "Shop"
          },
          "desc_html": "",
          "html_desc": "",
          "learn_more_text": "",
          "margin_bottom": 0,
          "margin_top": 0,
          "open_set_key": "",
          "price": "$15.04",
          "price_num": 15.04,
          "product_id": 15451888648326,
          "product_image_id": 0,
          "product_image_scale": "100",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/ADMTL09-tin-master.png?v=1793150187&width=400",
          "product_url": "/products/americana-decor-metallics-tin",
          "product_variant_id": 67786297573510,
          "scale": "100",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "swatch_image_zoom": "100",
          "swatch_mode": true,
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/ADMTL09-tin-3d.png?v=1793143401&width=400",
          "title": "Tin",
          "type": "product",
          "vjust": "center"
        },
        {
          "alt": "Pewter",
          "available": true,
          "buttons_over_image": false,
          "cta": {
            "href": "/products/americana-decor-metallics-pewter",
            "text": "Shop"
          },
          "desc_html": "",
          "html_desc": "",
          "learn_more_text": "",
          "margin_bottom": 0,
          "margin_top": 0,
          "open_set_key": "",
          "price": "$15.04",
          "price_num": 15.04,
          "product_id": 15451888681094,
          "product_image_id": 0,
          "product_image_scale": "100",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/ADMTL12-pewter-master.png?v=1793150187&width=400",
          "product_url": "/products/americana-decor-metallics-pewter",
          "product_variant_id": 67786297606278,
          "scale": "100",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "swatch_image_zoom": "100",
          "swatch_mode": true,
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/ADMTL12-pewter-3d.png?v=1793143401&width=400",
          "title": "Pewter",
          "type": "product",
          "vjust": "center"
        },
        {
          "alt": "Garnet",
          "available": true,
          "buttons_over_image": false,
          "cta": {
            "href": "/products/americana-decor-metallics-garnet",
            "text": "Shop"
          },
          "desc_html": "",
          "html_desc": "",
          "learn_more_text": "",
          "margin_bottom": 0,
          "margin_top": 0,
          "open_set_key": "",
          "price": "$15.04",
          "price_num": 15.04,
          "product_id": 15451888713862,
          "product_image_id": 0,
          "product_image_scale": "100",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/ADMTL15-garnet-master.png?v=1793150187&width=400",
          "product_url": "/products/americana-decor-metallics-garnet",
          "product_variant_id": 67786297639046,
          "scale": "100",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "swatch_image_zoom": "100",
          "swatch_mode": true,
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/ADMTL15-garnet-3d.png?v=1793143401&width=400",
          "title": "Garnet",
          "type": "product",
          "vjust": "center"
        },
        {
          "alt": "Berry",
          "available": true,
          "buttons_over_image": false,
          "cta": {
            "href": "/products/americana-decor-metallics-berry",
            "text": "Shop"
          },
          "desc_html": "",
          "html_desc": "",
          "learn_more_text": "",
          "margin_bottom": 0,
          "margin_top": 0,
          "open_set_key": "",
          "price": "$15.04",
          "price_num": 15.04,
          "product_id": 15451888746630,
          "product_image_id": 0,
          "product_image_scale": "100",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/ADMTL16-berry-master.png?v=1793150188&width=400",
          "product_url": "/products/americana-decor-metallics-berry",
          "product_variant_id": 67786297671814,
          "scale": "100",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "swatch_image_zoom": "100",
          "swatch_mode": true,
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/ADMTL16-berry-3d.png?v=1793143401&width=400",
          "title": "Berry",
          "type": "product",
          "vjust": "center"
        },
        {
          "alt": "Amethyst",
          "available": true,
          "buttons_over_image": false,
          "cta": {
            "href": "/products/americana-decor-metallics-amethyst",
            "text": "Shop"
          },
          "desc_html": "",
          "html_desc": "",
          "learn_more_text": "",
          "margin_bottom": 0,
          "margin_top": 0,
          "open_set_key": "",
          "price": "$4.99",
          "price_num": 4.99,
          "product_id": 15451888779398,
          "product_image_id": 0,
          "product_image_scale": "100",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/ADMTL20-amethyst-master.png?v=1793150187&width=400",
          "product_url": "/products/americana-decor-metallics-amethyst",
          "product_variant_id": 67786297704582,
          "scale": "100",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "swatch_image_zoom": "100",
          "swatch_mode": true,
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/ADMTL20-amethyst-3d.png?v=1793143401&width=400",
          "title": "Amethyst",
          "type": "product",
          "vjust": "center"
        },
        {
          "alt": "Sapphire",
          "available": true,
          "buttons_over_image": false,
          "cta": {
            "href": "/products/americana-decor-metallics-sapphire",
            "text": "Shop"
          },
          "desc_html": "",
          "html_desc": "",
          "learn_more_text": "",
          "margin_bottom": 0,
          "margin_top": 0,
          "open_set_key": "",
          "price": "$15.04",
          "price_num": 15.04,
          "product_id": 15451888910470,
          "product_image_id": 0,
          "product_image_scale": "100",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/ADMTL18-sapphire-master.png?v=1793150187&width=400",
          "product_url": "/products/americana-decor-metallics-sapphire",
          "product_variant_id": 67786297835654,
          "scale": "100",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "swatch_image_zoom": "100",
          "swatch_mode": true,
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/ADMTL18-sapphire-3d.png?v=1793143401&width=400",
          "title": "Sapphire",
          "type": "product",
          "vjust": "center"
        },
        {
          "alt": "Deep Sapphire",
          "available": true,
          "buttons_over_image": false,
          "cta": {
            "href": "/products/americana-decor-metallics-deep-sapphire",
            "text": "Shop"
          },
          "desc_html": "",
          "html_desc": "",
          "learn_more_text": "",
          "margin_bottom": 0,
          "margin_top": 0,
          "open_set_key": "",
          "price": "$4.99",
          "price_num": 4.99,
          "product_id": 15451888943238,
          "product_image_id": 0,
          "product_image_scale": "100",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/ADMTL19-deep-sapphire-master.png?v=1793150188&width=400",
          "product_url": "/products/americana-decor-metallics-deep-sapphire",
          "product_variant_id": 67786297868422,
          "scale": "100",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "swatch_image_zoom": "100",
          "swatch_mode": true,
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/ADMTL19-deep-sapphire-3d.png?v=1793143401&width=400",
          "title": "Deep Sapphire",
          "type": "product",
          "vjust": "center"
        },
        {
          "alt": "Emerald",
          "available": true,
          "buttons_over_image": false,
          "cta": {
            "href": "/products/americana-decor-metallics-emerald",
            "text": "Shop"
          },
          "desc_html": "",
          "html_desc": "",
          "learn_more_text": "",
          "margin_bottom": 0,
          "margin_top": 0,
          "open_set_key": "",
          "price": "$15.04",
          "price_num": 15.04,
          "product_id": 15451888976006,
          "product_image_id": 0,
          "product_image_scale": "100",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/ADMTL17-emerald-master.png?v=1793150187&width=400",
          "product_url": "/products/americana-decor-metallics-emerald",
          "product_variant_id": 67786297901190,
          "scale": "100",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "swatch_image_zoom": "100",
          "swatch_mode": true,
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/ADMTL17-emerald-3d.png?v=1793143401&width=400",
          "title": "Emerald",
          "type": "product",
          "vjust": "center"
        },
        {
          "alt": "Obsidian",
          "available": true,
          "buttons_over_image": false,
          "cta": {
            "href": "/products/americana-decor-metallics-obsidian",
            "text": "Shop"
          },
          "desc_html": "",
          "html_desc": "",
          "learn_more_text": "",
          "margin_bottom": 0,
          "margin_top": 0,
          "open_set_key": "",
          "price": "$15.04",
          "price_num": 15.04,
          "product_id": 15451889008774,
          "product_image_id": 0,
          "product_image_scale": "100",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/ADMTL21-obsidian-master.png?v=1793150187&width=400",
          "product_url": "/products/americana-decor-metallics-obsidian",
          "product_variant_id": 67786297933958,
          "scale": "100",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "swatch_image_zoom": "100",
          "swatch_mode": true,
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/ADMTL21-obsidian-3d.png?v=1793143401&width=400",
          "title": "Obsidian",
          "type": "product",
          "vjust": "center"
        }
      ],
      "swatches_per_row": 6,
      "swatches_per_row_desktop": 6,
      "swatches_per_row_mobile": 4,
      "videos": [
        {
          "alt": "24K Gold",
          "available": true,
          "buttons_over_image": false,
          "cta": {
            "href": "/products/americana-decor-metallics-24k-gold",
            "text": "Shop"
          },
          "desc_html": "",
          "html_desc": "",
          "learn_more_text": "",
          "margin_bottom": 0,
          "margin_top": 0,
          "open_set_key": "",
          "price": "$15.04",
          "price_num": 15.04,
          "product_id": 15451888124038,
          "product_image_id": 0,
          "product_image_scale": "100",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/ADMTL04-24k-gold-master.png?v=1793150187&width=400",
          "product_url": "/products/americana-decor-metallics-24k-gold",
          "product_variant_id": 67786296787078,
          "scale": "100",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "swatch_image_zoom": "100",
          "swatch_mode": true,
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/ADMTL04-24k-gold-3d.png?v=1793143401&width=400",
          "title": "24K Gold",
          "type": "product",
          "vjust": "center"
        },
        {
          "alt": "Champagne Gold",
          "available": true,
          "buttons_over_image": false,
          "cta": {
            "href": "/products/americana-decor-metallics-champagne-gold",
            "text": "Shop"
          },
          "desc_html": "",
          "html_desc": "",
          "learn_more_text": "",
          "margin_bottom": 0,
          "margin_top": 0,
          "open_set_key": "",
          "price": "$15.04",
          "price_num": 15.04,
          "product_id": 15451888156806,
          "product_image_id": 0,
          "product_image_scale": "100",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/ADMTL02-champagne-gold-master.png?v=1793150187&width=400",
          "product_url": "/products/americana-decor-metallics-champagne-gold",
          "product_variant_id": 67786296819846,
          "scale": "100",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "swatch_image_zoom": "100",
          "swatch_mode": true,
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/ADMTL02-champagne-gold-3d.png?v=1793143401&width=400",
          "title": "Champagne Gold",
          "type": "product",
          "vjust": "center"
        },
        {
          "alt": "Soft Gold",
          "available": true,
          "buttons_over_image": false,
          "cta": {
            "href": "/products/americana-decor-metallics-soft-gold",
            "text": "Shop"
          },
          "desc_html": "",
          "html_desc": "",
          "learn_more_text": "",
          "margin_bottom": 0,
          "margin_top": 0,
          "open_set_key": "",
          "price": "$4.99",
          "price_num": 4.99,
          "product_id": 15451888189574,
          "product_image_id": 0,
          "product_image_scale": "100",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/ADMTL14-soft-gold-master.png?v=1793150186&width=400",
          "product_url": "/products/americana-decor-metallics-soft-gold",
          "product_variant_id": 67786296885382,
          "scale": "100",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "swatch_image_zoom": "100",
          "swatch_mode": true,
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/ADMTL14-soft-gold-3d.png?v=1793143401&width=400",
          "title": "Soft Gold",
          "type": "product",
          "vjust": "center"
        },
        {
          "alt": "Vintage Brass",
          "available": true,
          "buttons_over_image": false,
          "cta": {
            "href": "/products/americana-decor-metallics-vintage-brass",
            "text": "Shop"
          },
          "desc_html": "",
          "html_desc": "",
          "learn_more_text": "",
          "margin_bottom": 0,
          "margin_top": 0,
          "open_set_key": "",
          "price": "$15.04",
          "price_num": 15.04,
          "product_id": 15451888255110,
          "product_image_id": 0,
          "product_image_scale": "100",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/ADMTL05-vintage-brass-master.png?v=1793150188&width=400",
          "product_url": "/products/americana-decor-metallics-vintage-brass",
          "product_variant_id": 67786296918150,
          "scale": "100",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "swatch_image_zoom": "100",
          "swatch_mode": true,
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/ADMTL05-vintage-brass-3d.png?v=1793143401&width=400",
          "title": "Vintage Brass",
          "type": "product",
          "vjust": "center"
        },
        {
          "alt": "Bronze",
          "available": true,
          "buttons_over_image": false,
          "cta": {
            "href": "/products/americana-decor-metallics-bronze",
            "text": "Shop"
          },
          "desc_html": "",
          "html_desc": "",
          "learn_more_text": "",
          "margin_bottom": 0,
          "margin_top": 0,
          "open_set_key": "",
          "price": "$15.04",
          "price_num": 15.04,
          "product_id": 15451888320646,
          "product_image_id": 0,
          "product_image_scale": "100",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/ADMTL06-bronze-master.png?v=1793150187&width=400",
          "product_url": "/products/americana-decor-metallics-bronze",
          "product_variant_id": 67786296983686,
          "scale": "100",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "swatch_image_zoom": "100",
          "swatch_mode": true,
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/ADMTL06-bronze-3d.png?v=1793143401&width=400",
          "title": "Bronze",
          "type": "product",
          "vjust": "center"
        },
        {
          "alt": "Antique Bronze",
          "available": true,
          "buttons_over_image": false,
          "cta": {
            "href": "/products/americana-decor-metallics-antique-bronze",
            "text": "Shop"
          },
          "desc_html": "",
          "html_desc": "",
          "learn_more_text": "",
          "margin_bottom": 0,
          "margin_top": 0,
          "open_set_key": "",
          "price": "$4.99",
          "price_num": 4.99,
          "product_id": 15451888353414,
          "product_image_id": 0,
          "product_image_scale": "100",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/ADMTL08-antique-bronze-master.png?v=1793150188&width=400",
          "product_url": "/products/americana-decor-metallics-antique-bronze",
          "product_variant_id": 67786297016454,
          "scale": "100",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "swatch_image_zoom": "100",
          "swatch_mode": true,
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/ADMTL08-antique-bronze-3d.png?v=1793143401&width=400",
          "title": "Antique Bronze",
          "type": "product",
          "vjust": "center"
        },
        {
          "alt": "Copper",
          "available": true,
          "buttons_over_image": false,
          "cta": {
            "href": "/products/americana-decor-metallics-copper",
            "text": "Shop"
          },
          "desc_html": "",
          "html_desc": "",
          "learn_more_text": "",
          "margin_bottom": 0,
          "margin_top": 0,
          "open_set_key": "",
          "price": "$15.04",
          "price_num": 15.04,
          "product_id": 15451888386182,
          "product_image_id": 0,
          "product_image_scale": "100",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/ADMTL10-copper-master.png?v=1793150187&width=400",
          "product_url": "/products/americana-decor-metallics-copper",
          "product_variant_id": 67786297049222,
          "scale": "100",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "swatch_image_zoom": "100",
          "swatch_mode": true,
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/ADMTL10-copper-3d.png?v=1793143400&width=400",
          "title": "Copper",
          "type": "product",
          "vjust": "center"
        },
        {
          "alt": "Rose Gold",
          "available": true,
          "buttons_over_image": false,
          "cta": {
            "href": "/products/americana-decor-metallics-rose-gold",
            "text": "Shop"
          },
          "desc_html": "",
          "html_desc": "",
          "learn_more_text": "",
          "margin_bottom": 0,
          "margin_top": 0,
          "open_set_key": "",
          "price": "$15.04",
          "price_num": 15.04,
          "product_id": 15451888418950,
          "product_image_id": 0,
          "product_image_scale": "100",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/ADMTL03-rose-gold-master.png?v=1793150187&width=400",
          "product_url": "/products/americana-decor-metallics-rose-gold",
          "product_variant_id": 67786297081990,
          "scale": "100",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "swatch_image_zoom": "100",
          "swatch_mode": true,
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/ADMTL03-rose-gold-3d.png?v=1793143401&width=400",
          "title": "Rose Gold",
          "type": "product",
          "vjust": "center"
        },
        {
          "alt": "Pearl",
          "available": true,
          "buttons_over_image": false,
          "cta": {
            "href": "/products/americana-decor-metallics-pearl",
            "text": "Shop"
          },
          "desc_html": "",
          "html_desc": "",
          "learn_more_text": "",
          "margin_bottom": 0,
          "margin_top": 0,
          "open_set_key": "",
          "price": "$15.04",
          "price_num": 15.04,
          "product_id": 15451888484486,
          "product_image_id": 0,
          "product_image_scale": "100",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/ADMTL01-pearl-master.png?v=1793150187&width=400",
          "product_url": "/products/americana-decor-metallics-pearl",
          "product_variant_id": 67786297147526,
          "scale": "100",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "swatch_image_zoom": "100",
          "swatch_mode": true,
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/ADMTL01-pearl-3d.png?v=1793143400&width=400",
          "title": "Pearl",
          "type": "product",
          "vjust": "center"
        },
        {
          "alt": "Silver",
          "available": true,
          "buttons_over_image": false,
          "cta": {
            "href": "/products/americana-decor-metallics-silver",
            "text": "Shop"
          },
          "desc_html": "",
          "html_desc": "",
          "learn_more_text": "",
          "margin_bottom": 0,
          "margin_top": 0,
          "open_set_key": "",
          "price": "$15.04",
          "price_num": 15.04,
          "product_id": 15451888550022,
          "product_image_id": 0,
          "product_image_scale": "100",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/ADMTL13-silver-master.png?v=1793150187&width=400",
          "product_url": "/products/americana-decor-metallics-silver",
          "product_variant_id": 67786297475206,
          "scale": "100",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "swatch_image_zoom": "100",
          "swatch_mode": true,
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/ADMTL13-Silver-3D-Swatch.png?v=1793150759&width=400",
          "title": "Silver",
          "type": "product",
          "vjust": "center"
        },
        {
          "alt": "Sterling Silver",
          "available": true,
          "buttons_over_image": false,
          "cta": {
            "href": "/products/americana-decor-metallics-sterling-silver",
            "text": "Shop"
          },
          "desc_html": "",
          "html_desc": "",
          "learn_more_text": "",
          "margin_bottom": 0,
          "margin_top": 0,
          "open_set_key": "",
          "price": "$15.04",
          "price_num": 15.04,
          "product_id": 15451888582790,
          "product_image_id": 0,
          "product_image_scale": "100",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/ADMTL07-sterling-silver-master.png?v=1793150187&width=400",
          "product_url": "/products/americana-decor-metallics-sterling-silver",
          "product_variant_id": 67786297507974,
          "scale": "100",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "swatch_image_zoom": "100",
          "swatch_mode": true,
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/ADMTL07-Sterling-Silver-3D-Swatch.png?v=1793150759&width=400",
          "title": "Sterling Silver",
          "type": "product",
          "vjust": "center"
        },
        {
          "button_appearance_source": "inherit_from_parent",
          "button_image": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Americana-Metallics-View-All-20261027.png?v=1793144023&width=400",
          "button_image_alt": "View all Americana Decor Metallics colors",
          "button_justify": "left",
          "button_margin_top": "10",
          "button_max_width_px": "0",
          "button_style": "swatch",
          "button_text": "<p>View All</p>",
          "button_width_percent": 100,
          "include_visible_swatches_in_popup": true,
          "popup_swatches_per_row_desktop": "6",
          "popup_swatches_per_row_mobile": "4",
          "popup_title": "",
          "preset_button_background_color": "#f7f4ec",
          "preset_button_background_image": "",
          "preset_button_background_image_style": "center",
          "preset_button_border_color": "#cfcfcf",
          "preset_button_border_radius_px": 6,
          "preset_button_border_scope": "image_text",
          "preset_button_border_size": 2,
          "preset_button_gradient_angle": 42,
          "preset_button_gradient_color": "#f7f4ec",
          "preset_button_heading_justify": "left",
          "preset_button_image": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Americana-Metallics-View-All-20261027.png?v=1793144023&width=400",
          "preset_button_image_alt": "View all Americana Decor Metallics colors",
          "preset_button_image_height_desktop": "0",
          "preset_button_image_height_mobile": "0",
          "preset_button_image_radius_px": 6,
          "preset_button_product_image_padding": 0,
          "preset_button_shadow_size": 4,
          "preset_button_text_behavior": "wrap_text",
          "preset_button_text_color": "#000000",
          "preset_button_text_size_desktop": 14,
          "preset_button_text_size_mobile": 13,
          "preset_button_text_style": "normal",
          "type": "popup_remaining_swatches_trigger"
        },
        {
          "alt": "Tin",
          "available": true,
          "buttons_over_image": false,
          "cta": {
            "href": "/products/americana-decor-metallics-tin",
            "text": "Shop"
          },
          "desc_html": "",
          "html_desc": "",
          "learn_more_text": "",
          "margin_bottom": 0,
          "margin_top": 0,
          "open_set_key": "",
          "price": "$15.04",
          "price_num": 15.04,
          "product_id": 15451888648326,
          "product_image_id": 0,
          "product_image_scale": "100",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/ADMTL09-tin-master.png?v=1793150187&width=400",
          "product_url": "/products/americana-decor-metallics-tin",
          "product_variant_id": 67786297573510,
          "scale": "100",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "swatch_image_zoom": "100",
          "swatch_mode": true,
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/ADMTL09-tin-3d.png?v=1793143401&width=400",
          "title": "Tin",
          "type": "product",
          "vjust": "center"
        },
        {
          "alt": "Pewter",
          "available": true,
          "buttons_over_image": false,
          "cta": {
            "href": "/products/americana-decor-metallics-pewter",
            "text": "Shop"
          },
          "desc_html": "",
          "html_desc": "",
          "learn_more_text": "",
          "margin_bottom": 0,
          "margin_top": 0,
          "open_set_key": "",
          "price": "$15.04",
          "price_num": 15.04,
          "product_id": 15451888681094,
          "product_image_id": 0,
          "product_image_scale": "100",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/ADMTL12-pewter-master.png?v=1793150187&width=400",
          "product_url": "/products/americana-decor-metallics-pewter",
          "product_variant_id": 67786297606278,
          "scale": "100",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "swatch_image_zoom": "100",
          "swatch_mode": true,
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/ADMTL12-pewter-3d.png?v=1793143401&width=400",
          "title": "Pewter",
          "type": "product",
          "vjust": "center"
        },
        {
          "alt": "Garnet",
          "available": true,
          "buttons_over_image": false,
          "cta": {
            "href": "/products/americana-decor-metallics-garnet",
            "text": "Shop"
          },
          "desc_html": "",
          "html_desc": "",
          "learn_more_text": "",
          "margin_bottom": 0,
          "margin_top": 0,
          "open_set_key": "",
          "price": "$15.04",
          "price_num": 15.04,
          "product_id": 15451888713862,
          "product_image_id": 0,
          "product_image_scale": "100",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/ADMTL15-garnet-master.png?v=1793150187&width=400",
          "product_url": "/products/americana-decor-metallics-garnet",
          "product_variant_id": 67786297639046,
          "scale": "100",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "swatch_image_zoom": "100",
          "swatch_mode": true,
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/ADMTL15-garnet-3d.png?v=1793143401&width=400",
          "title": "Garnet",
          "type": "product",
          "vjust": "center"
        },
        {
          "alt": "Berry",
          "available": true,
          "buttons_over_image": false,
          "cta": {
            "href": "/products/americana-decor-metallics-berry",
            "text": "Shop"
          },
          "desc_html": "",
          "html_desc": "",
          "learn_more_text": "",
          "margin_bottom": 0,
          "margin_top": 0,
          "open_set_key": "",
          "price": "$15.04",
          "price_num": 15.04,
          "product_id": 15451888746630,
          "product_image_id": 0,
          "product_image_scale": "100",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/ADMTL16-berry-master.png?v=1793150188&width=400",
          "product_url": "/products/americana-decor-metallics-berry",
          "product_variant_id": 67786297671814,
          "scale": "100",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "swatch_image_zoom": "100",
          "swatch_mode": true,
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/ADMTL16-berry-3d.png?v=1793143401&width=400",
          "title": "Berry",
          "type": "product",
          "vjust": "center"
        },
        {
          "alt": "Amethyst",
          "available": true,
          "buttons_over_image": false,
          "cta": {
            "href": "/products/americana-decor-metallics-amethyst",
            "text": "Shop"
          },
          "desc_html": "",
          "html_desc": "",
          "learn_more_text": "",
          "margin_bottom": 0,
          "margin_top": 0,
          "open_set_key": "",
          "price": "$4.99",
          "price_num": 4.99,
          "product_id": 15451888779398,
          "product_image_id": 0,
          "product_image_scale": "100",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/ADMTL20-amethyst-master.png?v=1793150187&width=400",
          "product_url": "/products/americana-decor-metallics-amethyst",
          "product_variant_id": 67786297704582,
          "scale": "100",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "swatch_image_zoom": "100",
          "swatch_mode": true,
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/ADMTL20-amethyst-3d.png?v=1793143401&width=400",
          "title": "Amethyst",
          "type": "product",
          "vjust": "center"
        },
        {
          "alt": "Sapphire",
          "available": true,
          "buttons_over_image": false,
          "cta": {
            "href": "/products/americana-decor-metallics-sapphire",
            "text": "Shop"
          },
          "desc_html": "",
          "html_desc": "",
          "learn_more_text": "",
          "margin_bottom": 0,
          "margin_top": 0,
          "open_set_key": "",
          "price": "$15.04",
          "price_num": 15.04,
          "product_id": 15451888910470,
          "product_image_id": 0,
          "product_image_scale": "100",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/ADMTL18-sapphire-master.png?v=1793150187&width=400",
          "product_url": "/products/americana-decor-metallics-sapphire",
          "product_variant_id": 67786297835654,
          "scale": "100",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "swatch_image_zoom": "100",
          "swatch_mode": true,
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/ADMTL18-sapphire-3d.png?v=1793143401&width=400",
          "title": "Sapphire",
          "type": "product",
          "vjust": "center"
        },
        {
          "alt": "Deep Sapphire",
          "available": true,
          "buttons_over_image": false,
          "cta": {
            "href": "/products/americana-decor-metallics-deep-sapphire",
            "text": "Shop"
          },
          "desc_html": "",
          "html_desc": "",
          "learn_more_text": "",
          "margin_bottom": 0,
          "margin_top": 0,
          "open_set_key": "",
          "price": "$4.99",
          "price_num": 4.99,
          "product_id": 15451888943238,
          "product_image_id": 0,
          "product_image_scale": "100",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/ADMTL19-deep-sapphire-master.png?v=1793150188&width=400",
          "product_url": "/products/americana-decor-metallics-deep-sapphire",
          "product_variant_id": 67786297868422,
          "scale": "100",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "swatch_image_zoom": "100",
          "swatch_mode": true,
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/ADMTL19-deep-sapphire-3d.png?v=1793143401&width=400",
          "title": "Deep Sapphire",
          "type": "product",
          "vjust": "center"
        },
        {
          "alt": "Emerald",
          "available": true,
          "buttons_over_image": false,
          "cta": {
            "href": "/products/americana-decor-metallics-emerald",
            "text": "Shop"
          },
          "desc_html": "",
          "html_desc": "",
          "learn_more_text": "",
          "margin_bottom": 0,
          "margin_top": 0,
          "open_set_key": "",
          "price": "$15.04",
          "price_num": 15.04,
          "product_id": 15451888976006,
          "product_image_id": 0,
          "product_image_scale": "100",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/ADMTL17-emerald-master.png?v=1793150187&width=400",
          "product_url": "/products/americana-decor-metallics-emerald",
          "product_variant_id": 67786297901190,
          "scale": "100",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "swatch_image_zoom": "100",
          "swatch_mode": true,
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/ADMTL17-emerald-3d.png?v=1793143401&width=400",
          "title": "Emerald",
          "type": "product",
          "vjust": "center"
        },
        {
          "alt": "Obsidian",
          "available": true,
          "buttons_over_image": false,
          "cta": {
            "href": "/products/americana-decor-metallics-obsidian",
            "text": "Shop"
          },
          "desc_html": "",
          "html_desc": "",
          "learn_more_text": "",
          "margin_bottom": 0,
          "margin_top": 0,
          "open_set_key": "",
          "price": "$15.04",
          "price_num": 15.04,
          "product_id": 15451889008774,
          "product_image_id": 0,
          "product_image_scale": "100",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/ADMTL21-obsidian-master.png?v=1793150187&width=400",
          "product_url": "/products/americana-decor-metallics-obsidian",
          "product_variant_id": 67786297933958,
          "scale": "100",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "swatch_image_zoom": "100",
          "swatch_mode": true,
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/ADMTL21-obsidian-3d.png?v=1793143401&width=400",
          "title": "Obsidian",
          "type": "product",
          "vjust": "center"
        }
      ]
    }
  ]
};

// Native MG metallic paint range selector.
window.MG_SWATCH_SETS["Metallics-Families"] = {
  "meta": {
    "appearance": {
      "background_color": "#f7f4ec",
      "background_image": "",
      "background_image_style": "center",
      "border_color": "#cfcfcf",
      "border_radius_px": 6,
      "border_scope": "image_text",
      "border_size": 2,
      "gradient_angle": 42,
      "gradient_color": "#f7f4ec",
      "image_radius_px": 6,
      "product_image_padding": 0,
      "shadow_size": 4,
      "text_behavior": "wrap_text",
      "text_color": "#000000",
      "text_size_desktop": 16,
      "text_size_mobile": 14,
      "text_style": "normal"
    },
    "selected_appearance": {
      "background_color": "#f5f5f5",
      "background_image": "",
      "background_image_style": "center",
      "border_color": "#12316f",
      "border_radius_px": 6,
      "border_scope": "image_text",
      "border_size": 4,
      "gradient_color": "#f7f4ec",
      "image_radius_px": 4,
      "product_image_padding": 0,
      "shadow_size": 8,
      "text_color": "#000000",
      "text_style": "normal",
      "text_size_mobile": 12,
      "text_size_desktop": 13
    },
    "corner_radius_px": 6
  },
  "rows": [
    {
      "custom_html": "<span hidden data-ri29-metallic-families></span><style>.mgps-modal:has([data-ri29-metallic-families]){align-items:center!important;justify-content:center!important;padding:16px!important}.mgps-modal:has([data-ri29-metallic-families]) .mgps-modal__dialog{width:min(900px,calc(100vw - 32px))!important;max-width:900px!important;max-height:calc(100dvh - 32px)!important;margin:0!important}.mgps-modal:has([data-ri29-metallic-families]) .mgps-modal__body{min-height:0!important;max-height:calc(100dvh - 110px)!important;overflow:auto!important;overscroll-behavior:contain}.mgps-row:has([data-ri29-metallic-families]){display:none!important}.mgps-modal:has([data-ri29-metallic-families]) .mgps-img-wrap{height:230px!important;aspect-ratio:auto!important}.mgps-modal:has([data-ri29-metallic-families]) .mgps-img-inner img{object-fit:contain!important;object-position:center!important;width:100%!important;height:100%!important;transform:none!important}.mgps-modal:has([data-ri29-metallic-families]) .mgps-thumb-row{justify-content:center!important}.mgps-modal:has([data-ri29-metallic-families]) .mgps-title{font-size:16px!important;line-height:1.25!important;white-space:normal!important;transform:none!important}.mgps-modal:has([data-ri29-metallic-families]) .mgps-card-bottom{padding:12px 6px!important}@media(max-width:749px){.mgps-modal:has([data-ri29-metallic-families]) .mgps-img-wrap{height:160px!important}.mgps-modal:has([data-ri29-metallic-families]) .mgps-title{font-size:14px!important}}</style>",
      "custom_max_width_px": "0",
      "custom_template_id": "mgps-custom-template--28071579648134__metallic_colors-0",
      "custom_width_desktop_percent": "100",
      "custom_width_mobile_percent": "100",
      "fit_row": false,
      "heading": "",
      "heading_justify": "center",
      "img_ratio": "1:1",
      "margin_bottom": 0,
      "margin_top": "0",
      "row_height": 0,
      "row_justify": "center",
      "subheading": "",
      "swatch_row": false,
      "swatches": [],
      "videos": []
    },
    {
      "block_type": "mg_row",
      "find_product_handle_contains": "",
      "fit_row": true,
      "heading": "",
      "heading_justify": "left",
      "img_ratio": "1:1",
      "margin_bottom": 0,
      "margin_top": 0,
      "more_popup_text": "More",
      "padding_between_rows": 8,
      "padding_between_rows_desktop": 10,
      "padding_between_rows_mobile": 8,
      "product_handle_contains": "",
      "random_zoom_max": "0",
      "randomize_zoom_area": false,
      "row_display_type": "scale_to_fit",
      "row_display_type_desktop": "scale_to_fit",
      "row_display_type_mobile": "scale_to_fit",
      "row_height": "0",
      "row_height_desktop": "0",
      "row_height_mobile": "0",
      "row_justify": "center",
      "subheading": "",
      "swatch_image_zoom": "100",
      "swatch_row": true,
      "swatch_vertical_justify": "fit_to_height",
      "swatches": [
        {
          "alt": "Americana Decor Metallics",
          "available": true,
          "buttons_over_image": false,
          "cta": {
            "href": "/products/americana-decor-metallics-24k-gold",
            "text": "Explore"
          },
          "desc_html": "",
          "html_desc": "",
          "learn_more_text": "",
          "margin_bottom": 0,
          "margin_top": 0,
          "open_set_key": "",
          "price": "",
          "price_num": 0,
          "product_id": 15451888124038,
          "product_image_id": 0,
          "product_image_scale": "100",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/ADMTL04-24k-gold-master.png?v=1793150187&width=400",
          "product_url": "/products/americana-decor-metallics-24k-gold",
          "product_variant_id": 0,
          "scale": "100",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "swatch_image_zoom": "100",
          "swatch_mode": false,
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/ADMTL04-24k-gold-master.png?v=1793150187&width=400",
          "title": "Americana Decor Metallics",
          "type": "product",
          "vjust": "center"
        },
        {
          "alt": "Dazzling Metallics",
          "available": true,
          "buttons_over_image": false,
          "cta": {
            "href": "/products/dazzling-metallics-white-pearl",
            "text": "Explore"
          },
          "desc_html": "",
          "html_desc": "",
          "learn_more_text": "",
          "margin_bottom": 0,
          "margin_top": 0,
          "open_set_key": "",
          "price": "",
          "price_num": 0,
          "product_id": 15460142284934,
          "product_image_id": 0,
          "product_image_scale": "100",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/DA117-3-white-pearl-2oz.png?v=1793307172",
          "product_url": "/products/dazzling-metallics-white-pearl",
          "product_variant_id": 0,
          "scale": "100",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "swatch_image_zoom": "100",
          "swatch_mode": false,
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/DA117-3-white-pearl-2oz.png?v=1793307172",
          "title": "Dazzling Metallics",
          "type": "product",
          "vjust": "center"
        },
        {
          "alt": "DecoArt® Metallic Lustre metallic wax finish",
          "available": true,
          "buttons_over_image": false,
          "cta": {
            "href": "/products/metallic-lustre-gold-rush",
            "text": "Explore"
          },
          "desc_html": "",
          "html_desc": "",
          "learn_more_text": "",
          "margin_bottom": 0,
          "margin_top": 0,
          "open_set_key": "",
          "price": "",
          "price_num": 0,
          "product_id": 15461447008390,
          "product_image_id": 0,
          "product_image_scale": "100",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/ML02C-28-gold-rush.png?v=1793397793&width=400",
          "product_url": "/products/metallic-lustre-gold-rush",
          "product_variant_id": 0,
          "scale": "100",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "swatch_image_zoom": "100",
          "swatch_mode": false,
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/ML02C-28-gold-rush.png?v=1793397793&width=400",
          "title": "Metallic Lustre",
          "type": "product",
          "vjust": "center"
        }
      ],
      "swatches_per_row": 3,
      "swatches_per_row_desktop": 3,
      "swatches_per_row_mobile": 2,
      "videos": [
        {
          "alt": "Americana Decor Metallics",
          "available": true,
          "buttons_over_image": false,
          "cta": {
            "href": "/products/americana-decor-metallics-24k-gold",
            "text": "Explore"
          },
          "desc_html": "",
          "html_desc": "",
          "learn_more_text": "",
          "margin_bottom": 0,
          "margin_top": 0,
          "open_set_key": "",
          "price": "",
          "price_num": 0,
          "product_id": 15451888124038,
          "product_image_id": 0,
          "product_image_scale": "100",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/ADMTL04-24k-gold-master.png?v=1793150187&width=400",
          "product_url": "/products/americana-decor-metallics-24k-gold",
          "product_variant_id": 0,
          "scale": "100",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "swatch_image_zoom": "100",
          "swatch_mode": false,
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/ADMTL04-24k-gold-master.png?v=1793150187&width=400",
          "title": "Americana Decor Metallics",
          "type": "product",
          "vjust": "center"
        },
        {
          "alt": "Dazzling Metallics",
          "available": true,
          "buttons_over_image": false,
          "cta": {
            "href": "/products/dazzling-metallics-white-pearl",
            "text": "Explore"
          },
          "desc_html": "",
          "html_desc": "",
          "learn_more_text": "",
          "margin_bottom": 0,
          "margin_top": 0,
          "open_set_key": "",
          "price": "",
          "price_num": 0,
          "product_id": 15460142284934,
          "product_image_id": 0,
          "product_image_scale": "100",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/DA117-3-white-pearl-2oz.png?v=1793307172",
          "product_url": "/products/dazzling-metallics-white-pearl",
          "product_variant_id": 0,
          "scale": "100",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "swatch_image_zoom": "100",
          "swatch_mode": false,
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/DA117-3-white-pearl-2oz.png?v=1793307172",
          "title": "Dazzling Metallics",
          "type": "product",
          "vjust": "center"
        },
        {
          "alt": "DecoArt® Metallic Lustre metallic wax finish",
          "available": true,
          "buttons_over_image": false,
          "cta": {
            "href": "/products/metallic-lustre-gold-rush",
            "text": "Explore"
          },
          "desc_html": "",
          "html_desc": "",
          "learn_more_text": "",
          "margin_bottom": 0,
          "margin_top": 0,
          "open_set_key": "",
          "price": "",
          "price_num": 0,
          "product_id": 15461447008390,
          "product_image_id": 0,
          "product_image_scale": "100",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/ML02C-28-gold-rush.png?v=1793397793&width=400",
          "product_url": "/products/metallic-lustre-gold-rush",
          "product_variant_id": 0,
          "scale": "100",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "swatch_image_zoom": "100",
          "swatch_mode": false,
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/ML02C-28-gold-rush.png?v=1793397793&width=400",
          "title": "Metallic Lustre",
          "type": "product",
          "vjust": "center"
        }
      ]
    }
  ]
};

// Native MG export: 24 Dazzling Metallics single-color draft listings.
window.MG_SWATCH_SETS["Colors-Dazzling"] = {
  "meta": {
    "appearance": {
      "background_color": "#f7f4ec",
      "background_image": "",
      "background_image_style": "center",
      "border_color": "#cfcfcf",
      "border_radius_px": 6,
      "border_scope": "image_text",
      "border_size": 2,
      "gradient_angle": 42,
      "gradient_color": "#f7f4ec",
      "image_radius_px": 6,
      "product_image_padding": 0,
      "shadow_size": 4,
      "text_behavior": "wrap_text",
      "text_color": "#000000",
      "text_size_desktop": 13,
      "text_size_mobile": 12,
      "text_style": "normal"
    },
    "selected_appearance": {
      "background_color": "#f5f5f5",
      "background_image": "",
      "background_image_style": "center",
      "border_color": "#12316f",
      "border_radius_px": 6,
      "border_scope": "image_text",
      "border_size": 4,
      "gradient_color": "#f7f4ec",
      "image_radius_px": 4,
      "product_image_padding": 0,
      "shadow_size": 8,
      "text_color": "#000000",
      "text_style": "normal",
      "text_size_mobile": 12,
      "text_size_desktop": 13
    },
    "corner_radius_px": 6
  },
  "rows": [
    {
      "custom_html": "<span hidden data-dazzling-compact-colors></span><style>:is([data-mg-set=\"Colors-Dazzling\"],[data-mg-set$=\"-dazzling_colors\"],[id$=\"__dazzling_colors\"],.mgps-modal:has([data-dazzling-compact-colors])) .mgps-img-wrap{--mgps-row-aspect:8 / 5!important;aspect-ratio:8 / 5!important;height:auto!important;min-height:0!important}:is([data-mg-set=\"Colors-Dazzling\"],[data-mg-set$=\"-dazzling_colors\"],[id$=\"__dazzling_colors\"],.mgps-modal:has([data-dazzling-compact-colors])) .mgps-img-inner img{width:100%!important;height:100%!important;object-fit:cover!important;object-position:center!important}:is([data-mg-set=\"Colors-Dazzling\"],[data-mg-set$=\"-dazzling_colors\"],[id$=\"__dazzling_colors\"]) img[src*=\"Dazzling-Metallics-View-All\"]{object-fit:contain!important}.mgps-row:has([data-dazzling-compact-colors]){display:none!important}.mgps-modal:has([data-dazzling-compact-colors]){align-items:center!important;justify-content:center!important;padding-block:16px!important;box-sizing:border-box!important}.mgps-modal:has([data-dazzling-compact-colors]) .mgps-modal__dialog{max-height:calc(100dvh - 32px)!important;margin:0!important}.mgps-modal:has([data-dazzling-compact-colors]) .mgps-modal__body{min-height:0!important;max-height:calc(100dvh - 32px)!important;overflow:auto!important;overscroll-behavior:contain}.mgps-modal:has([data-dazzling-compact-colors]) .mgps-thumb-row{justify-content:center!important}:is([data-mg-set=\"Colors-Dazzling\"],[data-mg-set$=\"-dazzling_colors\"],[id$=\"__dazzling_colors\"],.mgps-modal:has([data-dazzling-compact-colors])) .mgps-title{white-space:normal!important;overflow-wrap:normal!important;word-break:normal!important;transform:none!important;line-height:1.15!important}@media(max-width:749px){.mgps-modal:has([data-dazzling-compact-colors]){padding-inline:8px!important}.mgps-modal:has([data-dazzling-compact-colors]) .mgps-modal__dialog{width:calc(100vw - 16px)!important;max-width:calc(100vw - 16px)!important}:is([data-mg-set=\"Colors-Dazzling\"],[data-mg-set$=\"-dazzling_colors\"],[id$=\"__dazzling_colors\"],.mgps-modal:has([data-dazzling-compact-colors])) .mgps-card-bottom{padding:6px 3px!important;min-height:38px!important;box-sizing:border-box!important}:is([data-mg-set=\"Colors-Dazzling\"],[data-mg-set$=\"-dazzling_colors\"],[id$=\"__dazzling_colors\"],.mgps-modal:has([data-dazzling-compact-colors])) .mgps-title{font-size:12px!important}}</style>",
      "custom_max_width_px": "0",
      "custom_template_id": "mgps-custom-template--28071579648134__metallic_colors-0",
      "custom_width_desktop_percent": "100",
      "custom_width_mobile_percent": "100",
      "fit_row": false,
      "heading": "",
      "heading_justify": "center",
      "img_ratio": "1:1",
      "margin_bottom": 0,
      "margin_top": "0",
      "row_height": 0,
      "row_justify": "center",
      "subheading": "",
      "swatch_row": false,
      "swatches": [],
      "videos": []
    },
    {
      "block_type": "mg_row",
      "find_product_handle_contains": "",
      "fit_row": true,
      "heading": "<h2>Dazzling colors</h2>",
      "heading_justify": "left",
      "img_ratio": "1:1",
      "margin_bottom": 10,
      "margin_top": 0,
      "more_popup_text": "More",
      "padding_between_rows": 8,
      "padding_between_rows_desktop": 8,
      "padding_between_rows_mobile": 8,
      "product_handle_contains": "",
      "random_zoom_max": "0",
      "randomize_zoom_area": false,
      "row_display_type": "scale_to_fit",
      "row_display_type_desktop": "scale_to_fit",
      "row_display_type_mobile": "scale_to_fit",
      "row_height": "0",
      "row_height_desktop": "0",
      "row_height_mobile": "0",
      "row_justify": "center",
      "subheading": "",
      "swatch_image_zoom": "100",
      "swatch_row": true,
      "swatch_vertical_justify": "fit_to_height",
      "swatches": [
        {
          "alt": "White Pearl Dazzling Metallics paint swatch",
          "available": false,
          "buttons_over_image": false,
          "cta": {
            "href": "/products/dazzling-metallics-white-pearl",
            "text": "Shop"
          },
          "desc_html": "",
          "html_desc": "",
          "learn_more_text": "",
          "margin_bottom": 0,
          "margin_top": 0,
          "open_set_key": "",
          "price": "$3.61",
          "price_num": 3.61,
          "product_id": 15460142284934,
          "product_image_id": 0,
          "product_image_scale": "100",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/DA117-3-white-pearl-2oz.png?v=1793307172&width=400",
          "product_url": "/products/dazzling-metallics-white-pearl",
          "product_variant_id": 0,
          "scale": "100",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "swatch_image_zoom": "100",
          "swatch_mode": true,
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/DA117-white-pearl-dazzling-metallics-swatch.png?v=1793308674&width=400",
          "title": "White Pearl",
          "type": "product",
          "vjust": "center"
        },
        {
          "alt": "Purple Pearl Dazzling Metallics paint swatch",
          "available": false,
          "buttons_over_image": false,
          "cta": {
            "href": "/products/dazzling-metallics-purple-pearl",
            "text": "Shop"
          },
          "desc_html": "",
          "html_desc": "",
          "learn_more_text": "",
          "margin_bottom": 0,
          "margin_top": 0,
          "open_set_key": "",
          "price": "$3.61",
          "price_num": 3.61,
          "product_id": 15460145627270,
          "product_image_id": 0,
          "product_image_scale": "100",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/DA124-3-purple-pearl-2oz.png?v=1793307172&width=400",
          "product_url": "/products/dazzling-metallics-purple-pearl",
          "product_variant_id": 0,
          "scale": "100",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "swatch_image_zoom": "100",
          "swatch_mode": true,
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/DA124-purple-pearl-dazzling-metallics-swatch.png?v=1793308675&width=400",
          "title": "Purple Pearl",
          "type": "product",
          "vjust": "center"
        },
        {
          "alt": "Black Pearl Dazzling Metallics paint swatch",
          "available": false,
          "buttons_over_image": false,
          "cta": {
            "href": "/products/dazzling-metallics-black-pearl",
            "text": "Shop"
          },
          "desc_html": "",
          "html_desc": "",
          "learn_more_text": "",
          "margin_bottom": 0,
          "margin_top": 0,
          "open_set_key": "",
          "price": "$3.61",
          "price_num": 3.61,
          "product_id": 15460145692806,
          "product_image_id": 0,
          "product_image_scale": "100",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/DA127-3-black-pearl-2oz.png?v=1793307172&width=400",
          "product_url": "/products/dazzling-metallics-black-pearl",
          "product_variant_id": 0,
          "scale": "100",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "swatch_image_zoom": "100",
          "swatch_mode": true,
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/DA127-black-pearl-dazzling-metallics-swatch.png?v=1793308675&width=400",
          "title": "Black Pearl",
          "type": "product",
          "vjust": "center"
        },
        {
          "alt": "Emperor's Gold Dazzling Metallics paint swatch",
          "available": false,
          "buttons_over_image": false,
          "cta": {
            "href": "/products/dazzling-metallics-emperors-gold",
            "text": "Shop"
          },
          "desc_html": "",
          "html_desc": "",
          "learn_more_text": "",
          "margin_bottom": 0,
          "margin_top": 0,
          "open_set_key": "",
          "price": "$3.61",
          "price_num": 3.61,
          "product_id": 15460145725574,
          "product_image_id": 0,
          "product_image_scale": "100",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/DA148-3-emperors-gold-2oz.png?v=1793307172&width=400",
          "product_url": "/products/dazzling-metallics-emperors-gold",
          "product_variant_id": 0,
          "scale": "100",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "swatch_image_zoom": "100",
          "swatch_mode": true,
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/DA148-emperors-gold-dazzling-metallics-swatch.png?v=1793308675&width=400",
          "title": "Emperor's Gold",
          "type": "product",
          "vjust": "center"
        },
        {
          "alt": "Champagne Gold Dazzling Metallics paint swatch",
          "available": false,
          "buttons_over_image": false,
          "cta": {
            "href": "/products/dazzling-metallics-champagne-gold",
            "text": "Shop"
          },
          "desc_html": "",
          "html_desc": "",
          "learn_more_text": "",
          "margin_bottom": 0,
          "margin_top": 0,
          "open_set_key": "",
          "price": "$3.61",
          "price_num": 3.61,
          "product_id": 15460145823878,
          "product_image_id": 0,
          "product_image_scale": "100",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/DA202-3-champagne-gold-2oz.png?v=1793307172&width=400",
          "product_url": "/products/dazzling-metallics-champagne-gold",
          "product_variant_id": 0,
          "scale": "100",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "swatch_image_zoom": "100",
          "swatch_mode": true,
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/DA202-champagne-gold-dazzling-metallics-swatch.png?v=1793308675&width=400",
          "title": "Champagne Gold",
          "type": "product",
          "vjust": "center"
        },
        {
          "alt": "Copper Dazzling Metallics paint swatch",
          "available": false,
          "buttons_over_image": false,
          "cta": {
            "href": "/products/dazzling-metallics-copper",
            "text": "Shop"
          },
          "desc_html": "",
          "html_desc": "",
          "learn_more_text": "",
          "margin_bottom": 0,
          "margin_top": 0,
          "open_set_key": "",
          "price": "$3.61",
          "price_num": 3.61,
          "product_id": 15460145889414,
          "product_image_id": 0,
          "product_image_scale": "100",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/DA205-3-copper-2oz.png?v=1793307172&width=400",
          "product_url": "/products/dazzling-metallics-copper",
          "product_variant_id": 0,
          "scale": "100",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "swatch_image_zoom": "100",
          "swatch_mode": true,
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/DA205-copper-dazzling-metallics-swatch.png?v=1793308675&width=400",
          "title": "Copper",
          "type": "product",
          "vjust": "center"
        },
        {
          "alt": "Rich Espresso Dazzling Metallics paint swatch",
          "available": false,
          "buttons_over_image": false,
          "cta": {
            "href": "/products/dazzling-metallics-rich-espresso",
            "text": "Shop"
          },
          "desc_html": "",
          "html_desc": "",
          "learn_more_text": "",
          "margin_bottom": 0,
          "margin_top": 0,
          "open_set_key": "",
          "price": "$3.61",
          "price_num": 3.61,
          "product_id": 15460145922182,
          "product_image_id": 0,
          "product_image_scale": "100",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/DA245-3-rich-espresso-2oz.png?v=1793307172&width=400",
          "product_url": "/products/dazzling-metallics-rich-espresso",
          "product_variant_id": 0,
          "scale": "100",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "swatch_image_zoom": "100",
          "swatch_mode": true,
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/DA245-rich-espresso-dazzling-metallics-swatch.png?v=1793308675&width=400",
          "title": "Rich Espresso",
          "type": "product",
          "vjust": "center"
        },
        {
          "alt": "Festive Green Dazzling Metallics paint swatch",
          "available": false,
          "buttons_over_image": false,
          "cta": {
            "href": "/products/dazzling-metallics-festive-green",
            "text": "Shop"
          },
          "desc_html": "",
          "html_desc": "",
          "learn_more_text": "",
          "margin_bottom": 0,
          "margin_top": 0,
          "open_set_key": "",
          "price": "$3.61",
          "price_num": 3.61,
          "product_id": 15460145987718,
          "product_image_id": 0,
          "product_image_scale": "100",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/DA261-3-festive-green-2oz.png?v=1793307172&width=400",
          "product_url": "/products/dazzling-metallics-festive-green",
          "product_variant_id": 0,
          "scale": "100",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "swatch_image_zoom": "100",
          "swatch_mode": true,
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/DA261-festive-green-dazzling-metallics-swatch.png?v=1793308675&width=400",
          "title": "Festive Green",
          "type": "product",
          "vjust": "center"
        },
        {
          "alt": "Festive Red Dazzling Metallics paint swatch",
          "available": false,
          "buttons_over_image": false,
          "cta": {
            "href": "/products/dazzling-metallics-festive-red",
            "text": "Shop"
          },
          "desc_html": "",
          "html_desc": "",
          "learn_more_text": "",
          "margin_bottom": 0,
          "margin_top": 0,
          "open_set_key": "",
          "price": "$3.61",
          "price_num": 3.61,
          "product_id": 15460146020486,
          "product_image_id": 0,
          "product_image_scale": "100",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/DA262-3-festive-red-2oz.png?v=1793307172&width=400",
          "product_url": "/products/dazzling-metallics-festive-red",
          "product_variant_id": 0,
          "scale": "100",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "swatch_image_zoom": "100",
          "swatch_mode": true,
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/DA262-festive-red-dazzling-metallics-swatch.png?v=1793308676&width=400",
          "title": "Festive Red",
          "type": "product",
          "vjust": "center"
        },
        {
          "alt": "Splendid Gold Dazzling Metallics paint swatch",
          "available": false,
          "buttons_over_image": false,
          "cta": {
            "href": "/products/dazzling-metallics-splendid-gold",
            "text": "Shop"
          },
          "desc_html": "",
          "html_desc": "",
          "learn_more_text": "",
          "margin_bottom": 0,
          "margin_top": 0,
          "open_set_key": "",
          "price": "$3.61",
          "price_num": 3.61,
          "product_id": 15460146086022,
          "product_image_id": 0,
          "product_image_scale": "100",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/DA263-3-splendid-gold-2oz.png?v=1793307172&width=400",
          "product_url": "/products/dazzling-metallics-splendid-gold",
          "product_variant_id": 0,
          "scale": "100",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "swatch_image_zoom": "100",
          "swatch_mode": true,
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/DA263-splendid-gold-dazzling-metallics-swatch.png?v=1793308675&width=400",
          "title": "Splendid Gold",
          "type": "product",
          "vjust": "center"
        },
        {
          "alt": "Worn Penny Dazzling Metallics paint swatch",
          "available": false,
          "buttons_over_image": false,
          "cta": {
            "href": "/products/dazzling-metallics-worn-penny",
            "text": "Shop"
          },
          "desc_html": "",
          "html_desc": "",
          "learn_more_text": "",
          "margin_bottom": 0,
          "margin_top": 0,
          "open_set_key": "",
          "price": "$3.61",
          "price_num": 3.61,
          "product_id": 15460146151558,
          "product_image_id": 0,
          "product_image_scale": "100",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/DA287-3-worn-penny-2oz.png?v=1793307172&width=400",
          "product_url": "/products/dazzling-metallics-worn-penny",
          "product_variant_id": 0,
          "scale": "100",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "swatch_image_zoom": "100",
          "swatch_mode": true,
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/DA287-worn-penny-dazzling-metallics-swatch.png?v=1793308675&width=400",
          "title": "Worn Penny",
          "type": "product",
          "vjust": "center"
        },
        {
          "button_appearance_source": "inherit_from_parent",
          "button_image": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Dazzling-Metallics-View-All-20261029.png?v=1793308676&width=400",
          "button_image_alt": "View all Dazzling Metallics colors",
          "button_justify": "left",
          "button_margin_top": "10",
          "button_max_width_px": "0",
          "button_style": "swatch",
          "button_text": "<p>View All</p>",
          "button_width_percent": 100,
          "include_visible_swatches_in_popup": true,
          "popup_swatches_per_row_desktop": "6",
          "popup_swatches_per_row_mobile": "4",
          "popup_title": "",
          "preset_button_background_color": "#f7f4ec",
          "preset_button_background_image": "",
          "preset_button_background_image_style": "center",
          "preset_button_border_color": "#cfcfcf",
          "preset_button_border_radius_px": 6,
          "preset_button_border_scope": "image_text",
          "preset_button_border_size": 2,
          "preset_button_gradient_angle": 42,
          "preset_button_gradient_color": "#f7f4ec",
          "preset_button_heading_justify": "left",
          "preset_button_image": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Dazzling-Metallics-View-All-20261029.png?v=1793308676&width=400",
          "preset_button_image_alt": "View all Dazzling Metallics colors",
          "preset_button_image_height_desktop": "0",
          "preset_button_image_height_mobile": "0",
          "preset_button_image_radius_px": 6,
          "preset_button_product_image_padding": 0,
          "preset_button_shadow_size": 4,
          "preset_button_text_behavior": "wrap_text",
          "preset_button_text_color": "#000000",
          "preset_button_text_size_desktop": 14,
          "preset_button_text_size_mobile": 13,
          "preset_button_text_style": "normal",
          "type": "popup_remaining_swatches_trigger"
        },
        {
          "alt": "Peacock Pearl Dazzling Metallics paint swatch",
          "available": false,
          "buttons_over_image": false,
          "cta": {
            "href": "/products/dazzling-metallics-peacock-pearl",
            "text": "Shop"
          },
          "desc_html": "",
          "html_desc": "",
          "learn_more_text": "",
          "margin_bottom": 0,
          "margin_top": 0,
          "open_set_key": "",
          "price": "$3.61",
          "price_num": 3.61,
          "product_id": 15460146184326,
          "product_image_id": 0,
          "product_image_scale": "100",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/DA314-3-peacock-pearl-2oz.png?v=1793307172&width=400",
          "product_url": "/products/dazzling-metallics-peacock-pearl",
          "product_variant_id": 0,
          "scale": "100",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "swatch_image_zoom": "100",
          "swatch_mode": true,
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/DA314-peacock-pearl-dazzling-metallics-swatch.png?v=1793308675&width=400",
          "title": "Peacock Pearl",
          "type": "product",
          "vjust": "center"
        },
        {
          "alt": "Berry Dazzling Metallics paint swatch",
          "available": false,
          "buttons_over_image": false,
          "cta": {
            "href": "/products/dazzling-metallics-berry",
            "text": "Shop"
          },
          "desc_html": "",
          "html_desc": "",
          "learn_more_text": "",
          "margin_bottom": 0,
          "margin_top": 0,
          "open_set_key": "",
          "price": "$3.61",
          "price_num": 3.61,
          "product_id": 15460146217094,
          "product_image_id": 0,
          "product_image_scale": "100",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/DA320-3-berry-2oz.png?v=1793307172&width=400",
          "product_url": "/products/dazzling-metallics-berry",
          "product_variant_id": 0,
          "scale": "100",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "swatch_image_zoom": "100",
          "swatch_mode": true,
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/DA320-berry-dazzling-metallics-swatch.png?v=1793308674&width=400",
          "title": "Berry",
          "type": "product",
          "vjust": "center"
        },
        {
          "alt": "Amethyst Dazzling Metallics paint swatch",
          "available": false,
          "buttons_over_image": false,
          "cta": {
            "href": "/products/dazzling-metallics-amethyst",
            "text": "Shop"
          },
          "desc_html": "",
          "html_desc": "",
          "learn_more_text": "",
          "margin_bottom": 0,
          "margin_top": 0,
          "open_set_key": "",
          "price": "$3.61",
          "price_num": 3.61,
          "product_id": 15460146249862,
          "product_image_id": 0,
          "product_image_scale": "100",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/DA321-3-amethyst-2oz.png?v=1793307171&width=400",
          "product_url": "/products/dazzling-metallics-amethyst",
          "product_variant_id": 0,
          "scale": "100",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "swatch_image_zoom": "100",
          "swatch_mode": true,
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/DA321-amethyst-dazzling-metallics-swatch.png?v=1793308675&width=400",
          "title": "Amethyst",
          "type": "product",
          "vjust": "center"
        },
        {
          "alt": "Teal Dazzling Metallics paint swatch",
          "available": false,
          "buttons_over_image": false,
          "cta": {
            "href": "/products/dazzling-metallics-teal",
            "text": "Shop"
          },
          "desc_html": "",
          "html_desc": "",
          "learn_more_text": "",
          "margin_bottom": 0,
          "margin_top": 0,
          "open_set_key": "",
          "price": "$3.61",
          "price_num": 3.61,
          "product_id": 15460146282630,
          "product_image_id": 0,
          "product_image_scale": "100",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/DA322-3-teal-2oz.png?v=1793307172&width=400",
          "product_url": "/products/dazzling-metallics-teal",
          "product_variant_id": 0,
          "scale": "100",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "swatch_image_zoom": "100",
          "swatch_mode": true,
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/DA322-teal-dazzling-metallics-swatch.png?v=1793308675&width=400",
          "title": "Teal",
          "type": "product",
          "vjust": "center"
        },
        {
          "alt": "Bright Copper Dazzling Metallics paint swatch",
          "available": false,
          "buttons_over_image": false,
          "cta": {
            "href": "/products/dazzling-metallics-bright-copper",
            "text": "Shop"
          },
          "desc_html": "",
          "html_desc": "",
          "learn_more_text": "",
          "margin_bottom": 0,
          "margin_top": 0,
          "open_set_key": "",
          "price": "$3.61",
          "price_num": 3.61,
          "product_id": 15460146315398,
          "product_image_id": 0,
          "product_image_scale": "100",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/DA337-3-bright-copper-2oz.png?v=1793307171&width=400",
          "product_url": "/products/dazzling-metallics-bright-copper",
          "product_variant_id": 0,
          "scale": "100",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "swatch_image_zoom": "100",
          "swatch_mode": true,
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/DA337-bright-copper-dazzling-metallics-swatch.png?v=1793308675&width=400",
          "title": "Bright Copper",
          "type": "product",
          "vjust": "center"
        },
        {
          "alt": "Bright Brass Dazzling Metallics paint swatch",
          "available": false,
          "buttons_over_image": false,
          "cta": {
            "href": "/products/dazzling-metallics-bright-brass",
            "text": "Shop"
          },
          "desc_html": "",
          "html_desc": "",
          "learn_more_text": "",
          "margin_bottom": 0,
          "margin_top": 0,
          "open_set_key": "",
          "price": "$3.61",
          "price_num": 3.61,
          "product_id": 15460146348166,
          "product_image_id": 0,
          "product_image_scale": "100",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/DA338-3-bright-brass-2oz.png?v=1793307171&width=400",
          "product_url": "/products/dazzling-metallics-bright-brass",
          "product_variant_id": 0,
          "scale": "100",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "swatch_image_zoom": "100",
          "swatch_mode": true,
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/DA338-bright-brass-dazzling-metallics-swatch.png?v=1793308675&width=400",
          "title": "Bright Brass",
          "type": "product",
          "vjust": "center"
        },
        {
          "alt": "Zinc Dazzling Metallics paint swatch",
          "available": false,
          "buttons_over_image": false,
          "cta": {
            "href": "/products/dazzling-metallics-zinc",
            "text": "Shop"
          },
          "desc_html": "",
          "html_desc": "",
          "learn_more_text": "",
          "margin_bottom": 0,
          "margin_top": 0,
          "open_set_key": "",
          "price": "$3.61",
          "price_num": 3.61,
          "product_id": 15460146380934,
          "product_image_id": 0,
          "product_image_scale": "100",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/DA339-3-zinc-2oz.png?v=1793307172&width=400",
          "product_url": "/products/dazzling-metallics-zinc",
          "product_variant_id": 0,
          "scale": "100",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "swatch_image_zoom": "100",
          "swatch_mode": true,
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/DA339-zinc-dazzling-metallics-swatch.png?v=1793308675&width=400",
          "title": "Zinc",
          "type": "product",
          "vjust": "center"
        },
        {
          "alt": "Shimmering Silver Dazzling Metallics paint swatch",
          "available": false,
          "buttons_over_image": false,
          "cta": {
            "href": "/products/dazzling-metallics-shimmering-silver",
            "text": "Shop"
          },
          "desc_html": "",
          "html_desc": "",
          "learn_more_text": "",
          "margin_bottom": 0,
          "margin_top": 0,
          "open_set_key": "",
          "price": "$3.61",
          "price_num": 3.61,
          "product_id": 15460146479238,
          "product_image_id": 0,
          "product_image_scale": "100",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/DAO70-3-shimmering-silver-2oz.png?v=1793307172&width=400",
          "product_url": "/products/dazzling-metallics-shimmering-silver",
          "product_variant_id": 0,
          "scale": "100",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "swatch_image_zoom": "100",
          "swatch_mode": true,
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/DAO70-shimmering-silver-dazzling-metallics-swatch.png?v=1793308675&width=400",
          "title": "Shimmering Silver",
          "type": "product",
          "vjust": "center"
        },
        {
          "alt": "Venetian Gold Dazzling Metallics paint swatch",
          "available": false,
          "buttons_over_image": false,
          "cta": {
            "href": "/products/dazzling-metallics-venetian-gold",
            "text": "Shop"
          },
          "desc_html": "",
          "html_desc": "",
          "learn_more_text": "",
          "margin_bottom": 0,
          "margin_top": 0,
          "open_set_key": "",
          "price": "$3.61",
          "price_num": 3.61,
          "product_id": 15460146544774,
          "product_image_id": 0,
          "product_image_scale": "100",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/DAO72-3-venetian-gold-2oz.png?v=1793307172&width=400",
          "product_url": "/products/dazzling-metallics-venetian-gold",
          "product_variant_id": 0,
          "scale": "100",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "swatch_image_zoom": "100",
          "swatch_mode": true,
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/DAO72-venetian-gold-dazzling-metallics-swatch.png?v=1793308675&width=400",
          "title": "Venetian Gold",
          "type": "product",
          "vjust": "center"
        },
        {
          "alt": "Royal Ruby Dazzling Metallics paint swatch",
          "available": false,
          "buttons_over_image": false,
          "cta": {
            "href": "/products/dazzling-metallics-royal-ruby",
            "text": "Shop"
          },
          "desc_html": "",
          "html_desc": "",
          "learn_more_text": "",
          "margin_bottom": 0,
          "margin_top": 0,
          "open_set_key": "",
          "price": "$3.61",
          "price_num": 3.61,
          "product_id": 15460146577542,
          "product_image_id": 0,
          "product_image_scale": "100",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/DAO74-3-royal-ruby-2oz.png?v=1793307172&width=400",
          "product_url": "/products/dazzling-metallics-royal-ruby",
          "product_variant_id": 0,
          "scale": "100",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "swatch_image_zoom": "100",
          "swatch_mode": true,
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/DAO74-royal-ruby-dazzling-metallics-swatch.png?v=1793308675&width=400",
          "title": "Royal Ruby",
          "type": "product",
          "vjust": "center"
        },
        {
          "alt": "Ice Blue Dazzling Metallics paint swatch",
          "available": false,
          "buttons_over_image": false,
          "cta": {
            "href": "/products/dazzling-metallics-ice-blue",
            "text": "Shop"
          },
          "desc_html": "",
          "html_desc": "",
          "learn_more_text": "",
          "margin_bottom": 0,
          "margin_top": 0,
          "open_set_key": "",
          "price": "$3.61",
          "price_num": 3.61,
          "product_id": 15460146643078,
          "product_image_id": 0,
          "product_image_scale": "100",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/DAO75-3-ice-blue-2oz.png?v=1793307171&width=400",
          "product_url": "/products/dazzling-metallics-ice-blue",
          "product_variant_id": 0,
          "scale": "100",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "swatch_image_zoom": "100",
          "swatch_mode": true,
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/DAO75-ice-blue-dazzling-metallics-swatch.png?v=1793308675&width=400",
          "title": "Ice Blue",
          "type": "product",
          "vjust": "center"
        },
        {
          "alt": "Crystal Green Dazzling Metallics paint swatch",
          "available": false,
          "buttons_over_image": false,
          "cta": {
            "href": "/products/dazzling-metallics-crystal-green",
            "text": "Shop"
          },
          "desc_html": "",
          "html_desc": "",
          "learn_more_text": "",
          "margin_bottom": 0,
          "margin_top": 0,
          "open_set_key": "",
          "price": "$3.61",
          "price_num": 3.61,
          "product_id": 15460146708614,
          "product_image_id": 0,
          "product_image_scale": "100",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/DAO76-3-crystal-green-2oz.png?v=1793307171&width=400",
          "product_url": "/products/dazzling-metallics-crystal-green",
          "product_variant_id": 0,
          "scale": "100",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "swatch_image_zoom": "100",
          "swatch_mode": true,
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/DAO76-crystal-green-dazzling-metallics-swatch.png?v=1793308675&width=400",
          "title": "Crystal Green",
          "type": "product",
          "vjust": "center"
        },
        {
          "alt": "Glorious Gold Dazzling Metallics paint swatch",
          "available": false,
          "buttons_over_image": false,
          "cta": {
            "href": "/products/dazzling-metallics-glorious-gold",
            "text": "Shop"
          },
          "desc_html": "",
          "html_desc": "",
          "learn_more_text": "",
          "margin_bottom": 0,
          "margin_top": 0,
          "open_set_key": "",
          "price": "$3.61",
          "price_num": 3.61,
          "product_id": 15460146774150,
          "product_image_id": 0,
          "product_image_scale": "100",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/DAO71-3-glorious-gold-2oz.png?v=1793307172&width=400",
          "product_url": "/products/dazzling-metallics-glorious-gold",
          "product_variant_id": 0,
          "scale": "100",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "swatch_image_zoom": "100",
          "swatch_mode": true,
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/DAO71-glorious-gold-dazzling-metallics-swatch.png?v=1793308675&width=400",
          "title": "Glorious Gold",
          "type": "product",
          "vjust": "center"
        }
      ],
      "swatches_per_row": 6,
      "swatches_per_row_desktop": 6,
      "swatches_per_row_mobile": 4,
      "videos": [
        {
          "alt": "White Pearl Dazzling Metallics paint swatch",
          "available": false,
          "buttons_over_image": false,
          "cta": {
            "href": "/products/dazzling-metallics-white-pearl",
            "text": "Shop"
          },
          "desc_html": "",
          "html_desc": "",
          "learn_more_text": "",
          "margin_bottom": 0,
          "margin_top": 0,
          "open_set_key": "",
          "price": "$3.61",
          "price_num": 3.61,
          "product_id": 15460142284934,
          "product_image_id": 0,
          "product_image_scale": "100",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/DA117-3-white-pearl-2oz.png?v=1793307172&width=400",
          "product_url": "/products/dazzling-metallics-white-pearl",
          "product_variant_id": 0,
          "scale": "100",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "swatch_image_zoom": "100",
          "swatch_mode": true,
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/DA117-white-pearl-dazzling-metallics-swatch.png?v=1793308674&width=400",
          "title": "White Pearl",
          "type": "product",
          "vjust": "center"
        },
        {
          "alt": "Purple Pearl Dazzling Metallics paint swatch",
          "available": false,
          "buttons_over_image": false,
          "cta": {
            "href": "/products/dazzling-metallics-purple-pearl",
            "text": "Shop"
          },
          "desc_html": "",
          "html_desc": "",
          "learn_more_text": "",
          "margin_bottom": 0,
          "margin_top": 0,
          "open_set_key": "",
          "price": "$3.61",
          "price_num": 3.61,
          "product_id": 15460145627270,
          "product_image_id": 0,
          "product_image_scale": "100",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/DA124-3-purple-pearl-2oz.png?v=1793307172&width=400",
          "product_url": "/products/dazzling-metallics-purple-pearl",
          "product_variant_id": 0,
          "scale": "100",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "swatch_image_zoom": "100",
          "swatch_mode": true,
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/DA124-purple-pearl-dazzling-metallics-swatch.png?v=1793308675&width=400",
          "title": "Purple Pearl",
          "type": "product",
          "vjust": "center"
        },
        {
          "alt": "Black Pearl Dazzling Metallics paint swatch",
          "available": false,
          "buttons_over_image": false,
          "cta": {
            "href": "/products/dazzling-metallics-black-pearl",
            "text": "Shop"
          },
          "desc_html": "",
          "html_desc": "",
          "learn_more_text": "",
          "margin_bottom": 0,
          "margin_top": 0,
          "open_set_key": "",
          "price": "$3.61",
          "price_num": 3.61,
          "product_id": 15460145692806,
          "product_image_id": 0,
          "product_image_scale": "100",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/DA127-3-black-pearl-2oz.png?v=1793307172&width=400",
          "product_url": "/products/dazzling-metallics-black-pearl",
          "product_variant_id": 0,
          "scale": "100",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "swatch_image_zoom": "100",
          "swatch_mode": true,
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/DA127-black-pearl-dazzling-metallics-swatch.png?v=1793308675&width=400",
          "title": "Black Pearl",
          "type": "product",
          "vjust": "center"
        },
        {
          "alt": "Emperor's Gold Dazzling Metallics paint swatch",
          "available": false,
          "buttons_over_image": false,
          "cta": {
            "href": "/products/dazzling-metallics-emperors-gold",
            "text": "Shop"
          },
          "desc_html": "",
          "html_desc": "",
          "learn_more_text": "",
          "margin_bottom": 0,
          "margin_top": 0,
          "open_set_key": "",
          "price": "$3.61",
          "price_num": 3.61,
          "product_id": 15460145725574,
          "product_image_id": 0,
          "product_image_scale": "100",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/DA148-3-emperors-gold-2oz.png?v=1793307172&width=400",
          "product_url": "/products/dazzling-metallics-emperors-gold",
          "product_variant_id": 0,
          "scale": "100",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "swatch_image_zoom": "100",
          "swatch_mode": true,
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/DA148-emperors-gold-dazzling-metallics-swatch.png?v=1793308675&width=400",
          "title": "Emperor's Gold",
          "type": "product",
          "vjust": "center"
        },
        {
          "alt": "Champagne Gold Dazzling Metallics paint swatch",
          "available": false,
          "buttons_over_image": false,
          "cta": {
            "href": "/products/dazzling-metallics-champagne-gold",
            "text": "Shop"
          },
          "desc_html": "",
          "html_desc": "",
          "learn_more_text": "",
          "margin_bottom": 0,
          "margin_top": 0,
          "open_set_key": "",
          "price": "$3.61",
          "price_num": 3.61,
          "product_id": 15460145823878,
          "product_image_id": 0,
          "product_image_scale": "100",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/DA202-3-champagne-gold-2oz.png?v=1793307172&width=400",
          "product_url": "/products/dazzling-metallics-champagne-gold",
          "product_variant_id": 0,
          "scale": "100",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "swatch_image_zoom": "100",
          "swatch_mode": true,
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/DA202-champagne-gold-dazzling-metallics-swatch.png?v=1793308675&width=400",
          "title": "Champagne Gold",
          "type": "product",
          "vjust": "center"
        },
        {
          "alt": "Copper Dazzling Metallics paint swatch",
          "available": false,
          "buttons_over_image": false,
          "cta": {
            "href": "/products/dazzling-metallics-copper",
            "text": "Shop"
          },
          "desc_html": "",
          "html_desc": "",
          "learn_more_text": "",
          "margin_bottom": 0,
          "margin_top": 0,
          "open_set_key": "",
          "price": "$3.61",
          "price_num": 3.61,
          "product_id": 15460145889414,
          "product_image_id": 0,
          "product_image_scale": "100",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/DA205-3-copper-2oz.png?v=1793307172&width=400",
          "product_url": "/products/dazzling-metallics-copper",
          "product_variant_id": 0,
          "scale": "100",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "swatch_image_zoom": "100",
          "swatch_mode": true,
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/DA205-copper-dazzling-metallics-swatch.png?v=1793308675&width=400",
          "title": "Copper",
          "type": "product",
          "vjust": "center"
        },
        {
          "alt": "Rich Espresso Dazzling Metallics paint swatch",
          "available": false,
          "buttons_over_image": false,
          "cta": {
            "href": "/products/dazzling-metallics-rich-espresso",
            "text": "Shop"
          },
          "desc_html": "",
          "html_desc": "",
          "learn_more_text": "",
          "margin_bottom": 0,
          "margin_top": 0,
          "open_set_key": "",
          "price": "$3.61",
          "price_num": 3.61,
          "product_id": 15460145922182,
          "product_image_id": 0,
          "product_image_scale": "100",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/DA245-3-rich-espresso-2oz.png?v=1793307172&width=400",
          "product_url": "/products/dazzling-metallics-rich-espresso",
          "product_variant_id": 0,
          "scale": "100",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "swatch_image_zoom": "100",
          "swatch_mode": true,
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/DA245-rich-espresso-dazzling-metallics-swatch.png?v=1793308675&width=400",
          "title": "Rich Espresso",
          "type": "product",
          "vjust": "center"
        },
        {
          "alt": "Festive Green Dazzling Metallics paint swatch",
          "available": false,
          "buttons_over_image": false,
          "cta": {
            "href": "/products/dazzling-metallics-festive-green",
            "text": "Shop"
          },
          "desc_html": "",
          "html_desc": "",
          "learn_more_text": "",
          "margin_bottom": 0,
          "margin_top": 0,
          "open_set_key": "",
          "price": "$3.61",
          "price_num": 3.61,
          "product_id": 15460145987718,
          "product_image_id": 0,
          "product_image_scale": "100",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/DA261-3-festive-green-2oz.png?v=1793307172&width=400",
          "product_url": "/products/dazzling-metallics-festive-green",
          "product_variant_id": 0,
          "scale": "100",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "swatch_image_zoom": "100",
          "swatch_mode": true,
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/DA261-festive-green-dazzling-metallics-swatch.png?v=1793308675&width=400",
          "title": "Festive Green",
          "type": "product",
          "vjust": "center"
        },
        {
          "alt": "Festive Red Dazzling Metallics paint swatch",
          "available": false,
          "buttons_over_image": false,
          "cta": {
            "href": "/products/dazzling-metallics-festive-red",
            "text": "Shop"
          },
          "desc_html": "",
          "html_desc": "",
          "learn_more_text": "",
          "margin_bottom": 0,
          "margin_top": 0,
          "open_set_key": "",
          "price": "$3.61",
          "price_num": 3.61,
          "product_id": 15460146020486,
          "product_image_id": 0,
          "product_image_scale": "100",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/DA262-3-festive-red-2oz.png?v=1793307172&width=400",
          "product_url": "/products/dazzling-metallics-festive-red",
          "product_variant_id": 0,
          "scale": "100",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "swatch_image_zoom": "100",
          "swatch_mode": true,
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/DA262-festive-red-dazzling-metallics-swatch.png?v=1793308676&width=400",
          "title": "Festive Red",
          "type": "product",
          "vjust": "center"
        },
        {
          "alt": "Splendid Gold Dazzling Metallics paint swatch",
          "available": false,
          "buttons_over_image": false,
          "cta": {
            "href": "/products/dazzling-metallics-splendid-gold",
            "text": "Shop"
          },
          "desc_html": "",
          "html_desc": "",
          "learn_more_text": "",
          "margin_bottom": 0,
          "margin_top": 0,
          "open_set_key": "",
          "price": "$3.61",
          "price_num": 3.61,
          "product_id": 15460146086022,
          "product_image_id": 0,
          "product_image_scale": "100",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/DA263-3-splendid-gold-2oz.png?v=1793307172&width=400",
          "product_url": "/products/dazzling-metallics-splendid-gold",
          "product_variant_id": 0,
          "scale": "100",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "swatch_image_zoom": "100",
          "swatch_mode": true,
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/DA263-splendid-gold-dazzling-metallics-swatch.png?v=1793308675&width=400",
          "title": "Splendid Gold",
          "type": "product",
          "vjust": "center"
        },
        {
          "alt": "Worn Penny Dazzling Metallics paint swatch",
          "available": false,
          "buttons_over_image": false,
          "cta": {
            "href": "/products/dazzling-metallics-worn-penny",
            "text": "Shop"
          },
          "desc_html": "",
          "html_desc": "",
          "learn_more_text": "",
          "margin_bottom": 0,
          "margin_top": 0,
          "open_set_key": "",
          "price": "$3.61",
          "price_num": 3.61,
          "product_id": 15460146151558,
          "product_image_id": 0,
          "product_image_scale": "100",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/DA287-3-worn-penny-2oz.png?v=1793307172&width=400",
          "product_url": "/products/dazzling-metallics-worn-penny",
          "product_variant_id": 0,
          "scale": "100",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "swatch_image_zoom": "100",
          "swatch_mode": true,
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/DA287-worn-penny-dazzling-metallics-swatch.png?v=1793308675&width=400",
          "title": "Worn Penny",
          "type": "product",
          "vjust": "center"
        },
        {
          "button_appearance_source": "inherit_from_parent",
          "button_image": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Dazzling-Metallics-View-All-20261029.png?v=1793308676&width=400",
          "button_image_alt": "View all Dazzling Metallics colors",
          "button_justify": "left",
          "button_margin_top": "10",
          "button_max_width_px": "0",
          "button_style": "swatch",
          "button_text": "<p>View All</p>",
          "button_width_percent": 100,
          "include_visible_swatches_in_popup": true,
          "popup_swatches_per_row_desktop": "6",
          "popup_swatches_per_row_mobile": "4",
          "popup_title": "",
          "preset_button_background_color": "#f7f4ec",
          "preset_button_background_image": "",
          "preset_button_background_image_style": "center",
          "preset_button_border_color": "#cfcfcf",
          "preset_button_border_radius_px": 6,
          "preset_button_border_scope": "image_text",
          "preset_button_border_size": 2,
          "preset_button_gradient_angle": 42,
          "preset_button_gradient_color": "#f7f4ec",
          "preset_button_heading_justify": "left",
          "preset_button_image": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Dazzling-Metallics-View-All-20261029.png?v=1793308676&width=400",
          "preset_button_image_alt": "View all Dazzling Metallics colors",
          "preset_button_image_height_desktop": "0",
          "preset_button_image_height_mobile": "0",
          "preset_button_image_radius_px": 6,
          "preset_button_product_image_padding": 0,
          "preset_button_shadow_size": 4,
          "preset_button_text_behavior": "wrap_text",
          "preset_button_text_color": "#000000",
          "preset_button_text_size_desktop": 14,
          "preset_button_text_size_mobile": 13,
          "preset_button_text_style": "normal",
          "type": "popup_remaining_swatches_trigger"
        },
        {
          "alt": "Peacock Pearl Dazzling Metallics paint swatch",
          "available": false,
          "buttons_over_image": false,
          "cta": {
            "href": "/products/dazzling-metallics-peacock-pearl",
            "text": "Shop"
          },
          "desc_html": "",
          "html_desc": "",
          "learn_more_text": "",
          "margin_bottom": 0,
          "margin_top": 0,
          "open_set_key": "",
          "price": "$3.61",
          "price_num": 3.61,
          "product_id": 15460146184326,
          "product_image_id": 0,
          "product_image_scale": "100",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/DA314-3-peacock-pearl-2oz.png?v=1793307172&width=400",
          "product_url": "/products/dazzling-metallics-peacock-pearl",
          "product_variant_id": 0,
          "scale": "100",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "swatch_image_zoom": "100",
          "swatch_mode": true,
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/DA314-peacock-pearl-dazzling-metallics-swatch.png?v=1793308675&width=400",
          "title": "Peacock Pearl",
          "type": "product",
          "vjust": "center"
        },
        {
          "alt": "Berry Dazzling Metallics paint swatch",
          "available": false,
          "buttons_over_image": false,
          "cta": {
            "href": "/products/dazzling-metallics-berry",
            "text": "Shop"
          },
          "desc_html": "",
          "html_desc": "",
          "learn_more_text": "",
          "margin_bottom": 0,
          "margin_top": 0,
          "open_set_key": "",
          "price": "$3.61",
          "price_num": 3.61,
          "product_id": 15460146217094,
          "product_image_id": 0,
          "product_image_scale": "100",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/DA320-3-berry-2oz.png?v=1793307172&width=400",
          "product_url": "/products/dazzling-metallics-berry",
          "product_variant_id": 0,
          "scale": "100",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "swatch_image_zoom": "100",
          "swatch_mode": true,
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/DA320-berry-dazzling-metallics-swatch.png?v=1793308674&width=400",
          "title": "Berry",
          "type": "product",
          "vjust": "center"
        },
        {
          "alt": "Amethyst Dazzling Metallics paint swatch",
          "available": false,
          "buttons_over_image": false,
          "cta": {
            "href": "/products/dazzling-metallics-amethyst",
            "text": "Shop"
          },
          "desc_html": "",
          "html_desc": "",
          "learn_more_text": "",
          "margin_bottom": 0,
          "margin_top": 0,
          "open_set_key": "",
          "price": "$3.61",
          "price_num": 3.61,
          "product_id": 15460146249862,
          "product_image_id": 0,
          "product_image_scale": "100",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/DA321-3-amethyst-2oz.png?v=1793307171&width=400",
          "product_url": "/products/dazzling-metallics-amethyst",
          "product_variant_id": 0,
          "scale": "100",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "swatch_image_zoom": "100",
          "swatch_mode": true,
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/DA321-amethyst-dazzling-metallics-swatch.png?v=1793308675&width=400",
          "title": "Amethyst",
          "type": "product",
          "vjust": "center"
        },
        {
          "alt": "Teal Dazzling Metallics paint swatch",
          "available": false,
          "buttons_over_image": false,
          "cta": {
            "href": "/products/dazzling-metallics-teal",
            "text": "Shop"
          },
          "desc_html": "",
          "html_desc": "",
          "learn_more_text": "",
          "margin_bottom": 0,
          "margin_top": 0,
          "open_set_key": "",
          "price": "$3.61",
          "price_num": 3.61,
          "product_id": 15460146282630,
          "product_image_id": 0,
          "product_image_scale": "100",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/DA322-3-teal-2oz.png?v=1793307172&width=400",
          "product_url": "/products/dazzling-metallics-teal",
          "product_variant_id": 0,
          "scale": "100",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "swatch_image_zoom": "100",
          "swatch_mode": true,
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/DA322-teal-dazzling-metallics-swatch.png?v=1793308675&width=400",
          "title": "Teal",
          "type": "product",
          "vjust": "center"
        },
        {
          "alt": "Bright Copper Dazzling Metallics paint swatch",
          "available": false,
          "buttons_over_image": false,
          "cta": {
            "href": "/products/dazzling-metallics-bright-copper",
            "text": "Shop"
          },
          "desc_html": "",
          "html_desc": "",
          "learn_more_text": "",
          "margin_bottom": 0,
          "margin_top": 0,
          "open_set_key": "",
          "price": "$3.61",
          "price_num": 3.61,
          "product_id": 15460146315398,
          "product_image_id": 0,
          "product_image_scale": "100",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/DA337-3-bright-copper-2oz.png?v=1793307171&width=400",
          "product_url": "/products/dazzling-metallics-bright-copper",
          "product_variant_id": 0,
          "scale": "100",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "swatch_image_zoom": "100",
          "swatch_mode": true,
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/DA337-bright-copper-dazzling-metallics-swatch.png?v=1793308675&width=400",
          "title": "Bright Copper",
          "type": "product",
          "vjust": "center"
        },
        {
          "alt": "Bright Brass Dazzling Metallics paint swatch",
          "available": false,
          "buttons_over_image": false,
          "cta": {
            "href": "/products/dazzling-metallics-bright-brass",
            "text": "Shop"
          },
          "desc_html": "",
          "html_desc": "",
          "learn_more_text": "",
          "margin_bottom": 0,
          "margin_top": 0,
          "open_set_key": "",
          "price": "$3.61",
          "price_num": 3.61,
          "product_id": 15460146348166,
          "product_image_id": 0,
          "product_image_scale": "100",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/DA338-3-bright-brass-2oz.png?v=1793307171&width=400",
          "product_url": "/products/dazzling-metallics-bright-brass",
          "product_variant_id": 0,
          "scale": "100",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "swatch_image_zoom": "100",
          "swatch_mode": true,
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/DA338-bright-brass-dazzling-metallics-swatch.png?v=1793308675&width=400",
          "title": "Bright Brass",
          "type": "product",
          "vjust": "center"
        },
        {
          "alt": "Zinc Dazzling Metallics paint swatch",
          "available": false,
          "buttons_over_image": false,
          "cta": {
            "href": "/products/dazzling-metallics-zinc",
            "text": "Shop"
          },
          "desc_html": "",
          "html_desc": "",
          "learn_more_text": "",
          "margin_bottom": 0,
          "margin_top": 0,
          "open_set_key": "",
          "price": "$3.61",
          "price_num": 3.61,
          "product_id": 15460146380934,
          "product_image_id": 0,
          "product_image_scale": "100",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/DA339-3-zinc-2oz.png?v=1793307172&width=400",
          "product_url": "/products/dazzling-metallics-zinc",
          "product_variant_id": 0,
          "scale": "100",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "swatch_image_zoom": "100",
          "swatch_mode": true,
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/DA339-zinc-dazzling-metallics-swatch.png?v=1793308675&width=400",
          "title": "Zinc",
          "type": "product",
          "vjust": "center"
        },
        {
          "alt": "Shimmering Silver Dazzling Metallics paint swatch",
          "available": false,
          "buttons_over_image": false,
          "cta": {
            "href": "/products/dazzling-metallics-shimmering-silver",
            "text": "Shop"
          },
          "desc_html": "",
          "html_desc": "",
          "learn_more_text": "",
          "margin_bottom": 0,
          "margin_top": 0,
          "open_set_key": "",
          "price": "$3.61",
          "price_num": 3.61,
          "product_id": 15460146479238,
          "product_image_id": 0,
          "product_image_scale": "100",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/DAO70-3-shimmering-silver-2oz.png?v=1793307172&width=400",
          "product_url": "/products/dazzling-metallics-shimmering-silver",
          "product_variant_id": 0,
          "scale": "100",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "swatch_image_zoom": "100",
          "swatch_mode": true,
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/DAO70-shimmering-silver-dazzling-metallics-swatch.png?v=1793308675&width=400",
          "title": "Shimmering Silver",
          "type": "product",
          "vjust": "center"
        },
        {
          "alt": "Venetian Gold Dazzling Metallics paint swatch",
          "available": false,
          "buttons_over_image": false,
          "cta": {
            "href": "/products/dazzling-metallics-venetian-gold",
            "text": "Shop"
          },
          "desc_html": "",
          "html_desc": "",
          "learn_more_text": "",
          "margin_bottom": 0,
          "margin_top": 0,
          "open_set_key": "",
          "price": "$3.61",
          "price_num": 3.61,
          "product_id": 15460146544774,
          "product_image_id": 0,
          "product_image_scale": "100",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/DAO72-3-venetian-gold-2oz.png?v=1793307172&width=400",
          "product_url": "/products/dazzling-metallics-venetian-gold",
          "product_variant_id": 0,
          "scale": "100",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "swatch_image_zoom": "100",
          "swatch_mode": true,
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/DAO72-venetian-gold-dazzling-metallics-swatch.png?v=1793308675&width=400",
          "title": "Venetian Gold",
          "type": "product",
          "vjust": "center"
        },
        {
          "alt": "Royal Ruby Dazzling Metallics paint swatch",
          "available": false,
          "buttons_over_image": false,
          "cta": {
            "href": "/products/dazzling-metallics-royal-ruby",
            "text": "Shop"
          },
          "desc_html": "",
          "html_desc": "",
          "learn_more_text": "",
          "margin_bottom": 0,
          "margin_top": 0,
          "open_set_key": "",
          "price": "$3.61",
          "price_num": 3.61,
          "product_id": 15460146577542,
          "product_image_id": 0,
          "product_image_scale": "100",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/DAO74-3-royal-ruby-2oz.png?v=1793307172&width=400",
          "product_url": "/products/dazzling-metallics-royal-ruby",
          "product_variant_id": 0,
          "scale": "100",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "swatch_image_zoom": "100",
          "swatch_mode": true,
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/DAO74-royal-ruby-dazzling-metallics-swatch.png?v=1793308675&width=400",
          "title": "Royal Ruby",
          "type": "product",
          "vjust": "center"
        },
        {
          "alt": "Ice Blue Dazzling Metallics paint swatch",
          "available": false,
          "buttons_over_image": false,
          "cta": {
            "href": "/products/dazzling-metallics-ice-blue",
            "text": "Shop"
          },
          "desc_html": "",
          "html_desc": "",
          "learn_more_text": "",
          "margin_bottom": 0,
          "margin_top": 0,
          "open_set_key": "",
          "price": "$3.61",
          "price_num": 3.61,
          "product_id": 15460146643078,
          "product_image_id": 0,
          "product_image_scale": "100",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/DAO75-3-ice-blue-2oz.png?v=1793307171&width=400",
          "product_url": "/products/dazzling-metallics-ice-blue",
          "product_variant_id": 0,
          "scale": "100",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "swatch_image_zoom": "100",
          "swatch_mode": true,
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/DAO75-ice-blue-dazzling-metallics-swatch.png?v=1793308675&width=400",
          "title": "Ice Blue",
          "type": "product",
          "vjust": "center"
        },
        {
          "alt": "Crystal Green Dazzling Metallics paint swatch",
          "available": false,
          "buttons_over_image": false,
          "cta": {
            "href": "/products/dazzling-metallics-crystal-green",
            "text": "Shop"
          },
          "desc_html": "",
          "html_desc": "",
          "learn_more_text": "",
          "margin_bottom": 0,
          "margin_top": 0,
          "open_set_key": "",
          "price": "$3.61",
          "price_num": 3.61,
          "product_id": 15460146708614,
          "product_image_id": 0,
          "product_image_scale": "100",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/DAO76-3-crystal-green-2oz.png?v=1793307171&width=400",
          "product_url": "/products/dazzling-metallics-crystal-green",
          "product_variant_id": 0,
          "scale": "100",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "swatch_image_zoom": "100",
          "swatch_mode": true,
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/DAO76-crystal-green-dazzling-metallics-swatch.png?v=1793308675&width=400",
          "title": "Crystal Green",
          "type": "product",
          "vjust": "center"
        },
        {
          "alt": "Glorious Gold Dazzling Metallics paint swatch",
          "available": false,
          "buttons_over_image": false,
          "cta": {
            "href": "/products/dazzling-metallics-glorious-gold",
            "text": "Shop"
          },
          "desc_html": "",
          "html_desc": "",
          "learn_more_text": "",
          "margin_bottom": 0,
          "margin_top": 0,
          "open_set_key": "",
          "price": "$3.61",
          "price_num": 3.61,
          "product_id": 15460146774150,
          "product_image_id": 0,
          "product_image_scale": "100",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/DAO71-3-glorious-gold-2oz.png?v=1793307172&width=400",
          "product_url": "/products/dazzling-metallics-glorious-gold",
          "product_variant_id": 0,
          "scale": "100",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "swatch_image_zoom": "100",
          "swatch_mode": true,
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/DAO71-glorious-gold-dazzling-metallics-swatch.png?v=1793308675&width=400",
          "title": "Glorious Gold",
          "type": "product",
          "vjust": "center"
        }
      ]
    }
  ]
};
